/*
 * Stream Controller
*/

import BinarySearch from '../utils/binary-search';
import BufferHelper from '../helper/buffer-helper';
import Demuxer from '../demux/demuxer';
import Event from '../events';
import EventHandler from '../event-handler';
import TimeRanges from '../utils/timeRanges';
import { ErrorTypes, ErrorDetails } from '../errors';
import { logger } from '../utils/logger';
//for muxjs.mp4.tools
import muxjs from '../../muxjs';
require('core-js/fn/array');

const State = {
	STOPPED : 'STOPPED',
	IDLE : 'IDLE',
	KEY_LOADING : 'KEY_LOADING',
	FRAG_LOADING : 'FRAG_LOADING',
	FRAG_LOADING_WAITING_RETRY : 'FRAG_LOADING_WAITING_RETRY',
	WAITING_LEVEL : 'WAITING_LEVEL',
	PARSING : 'PARSING',
	PARSED : 'PARSED',
	BUFFER_FLUSHING : 'BUFFER_FLUSHING',
	ENDED : 'ENDED',
	ERROR : 'ERROR',
};

class StreamController extends EventHandler {

	constructor(hls) {
		super(hls,
			Event.MEDIA_ATTACHED,
			Event.MEDIA_DETACHING,
			Event.MANIFEST_LOADING,
			Event.MANIFEST_PARSED,
			Event.LEVEL_LOADED,
			//Mactrix additions start
			Event.STREAM_ALL_LEVELS_LOADED,
			Event.STREAM_DESYNC,
			//Mactrix additions end
			Event.KEY_LOADED,
			Event.FRAG_LOADED,
			Event.FRAG_LOAD_EMERGENCY_ABORTED,
			Event.FRAG_PARSING_INIT_SEGMENT,
			Event.FRAG_PARSING_DATA,
			Event.FRAG_PARSED,
			Event.ERROR,
			Event.AUDIO_TRACK_SWITCHING,
			Event.AUDIO_TRACK_SWITCHED,
			Event.BUFFER_CREATED,
			Event.BUFFER_APPENDED,
			Event.BUFFER_FLUSHED,
			Event.BUFFER_WAIT,
			Event.AUDIO_TRACK_UPDATED
		);

		this.config = hls.config;
		this._state = State.STOPPED;
		this._demuxer = undefined;

		this._ticks = 0;
		this.ontick = this.tick.bind(this);
		this._timer = undefined;

		this._audioCodecSwap = false;
		this._altAudio = false;
		this._audioCodecSwitch = false;

		this._endStallOffseter = 0;
		this._streamTimeoutArmed = false;
		this._playbackStarted = false;
		this._fragBufferCount = 0;
		this._fragLoadError = 0;
		this._flushOnStoppedBuffering = [];
		/*this._bufferNextDuplicate = false;*/

		this._slowDetachTicks = 0; //Backup if the seek does not complete

		this._lastCurrentTime = undefined;

		this._levels = [];
		this._level = 0;
		this._levelLastLoaded = undefined;
		this._stats = undefined;
		this._immediateSwitch = false;

		this._startFragRequested = false;
		this._loadedMetadata = false;
		this._nextLoadPosition = undefined;
		this._startPosition = undefined;

		this.forceStopFetching = false;
		this._fragCurrent = undefined;
		this._fragPrevious = undefined;
		this._fragLoadIdx = undefined;
		this._fragLastKbps = undefined;
		this._selectByPdt = false;//true;//hls.browSafari;
		this._clearFragPrevious = false;

		this._previouslyPaused = false;
		this._stalled = false;
		this._stallReported = false;
		this._nudgeRetry = 0;
		this._skipReloadDelay = false;

		this.liveSyncPosition = 0;
		this.initialPdt = undefined;

		this._pendingBuffering = false;
		this._appended = false;

		this._gapCycleBase = undefined;

		this._bufferBeforeSeekingTime = undefined;
		this._bufferBeforeSeekingApplied = undefined;
		this._waitForFlush = false;

		this._audioGapSeeking = false;

		this.videoBuffer = null;

		this._parsingDataCount = 0;
	}

	destroy() {
		this.stopLoad();
		if (this._timer) {
			clearInterval(this._timer);
			this._timer = null;
		}
		EventHandler.prototype.destroy.call(this);
	/*
	this._state = State.STOPPED;
	*/
	//Mactrix changes and additions start
	//memory clean up
		this.config = null;
		this._levels = null;
		this.ontick = null;
		this._stats = null;
		this.videoBuffer = null;
	//this.hls = null;
	//Mactrix additions end
	}

/* mactrix replace - new arguments
  startLoad(startPosition) {
*/
	startLoad() { //Mactrix line changed, start time and LSSALT are now handled by the coordinator so this doesn't need arguments any more

		if (this._levels) {
			const hls = this.hls;

			this.stopLoad();

			this._level = -1;
			this._fragLoadError = 0;
			if (!this._startFragRequested) {
				// determine load level
				let startLevel = hls.startLevel;
				if (startLevel === -1) {
					// -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
					startLevel = 0;
					this._bitrateTest = true;
				}
				// set new level to playlist loader : this will trigger start level load
				// hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
				this._level = hls.nextLoadLevel = startLevel;
				this._loadedMetadata = false;
				hls.trigger(Event.LEVEL_SELECTION_FINISHED);

			}

			this.state = State.IDLE;

		}
	}

  //Mactrix additions start
  //split load and fetch
	onStreamAllLevelsLoaded(data) {
		if (!this._timer) {
			this._timer = setInterval(this.ontick, 100);
		}


		//Disabling this for now

		//resync level as we are now guaranteed to have the base PDT
		//this.adjustStartByBasePdt(this._levels[this._level].details, this.hls.streamCoordinator.basePdt);

		this._playbackStarted = false;
		this._streamTimeoutArmed = true;

		this._nextLoadPosition = this._startPosition = this._lastCurrentTime = data.startTime;
		this.tick();

		logger.log(`onStreamAllLevelsLoaded MAIN this._startPosition: ${this._startPosition} this._lastCurrentTime: ${this._lastCurrentTime}`);
	}

  //fix desync
	onStreamDesync(data) {
		let i;
		let fragments = this._levels[this._level].details.fragments;
		let totalDropDuration = 0;
		let duration = fragments[0].manifestDuration;

	//sum the total duration that was removed, then sub that from all frags
		for(i = 0; fragments.length > 1 && fragments[0].pdt < data.pdtToAlignTo - data.variance; i++) {
			fragments.splice(0, 1);
			totalDropDuration += duration;
			duration = fragments[0].manifestDuration;
		}

		if(i > 0) {
			let j;

			logger.log('main PDT earlier than audio PDT, adjusting main timestamps');

			for(j = 0; j < fragments.length; j++) {
				fragments[j].index = j;
				fragments[j].start -= totalDropDuration;
				fragments[j].pdt -= totalDropDuration * 1000;
				fragments[j].sn -= i;
			}

			this._levels[this._level].details.endSN -= i;
		}
	}
  //Mactrix additions end

	stopLoad() {
	//Mactrix additions start
	//stop the tick when we stop loading
	//we only call stopLoad when we need to stop all functionality, so may as well halt timer here
	//if (this._timer) {
	//	clearInterval(this._timer);
	//	this._timer = null;
	//}
	// Removing this for now. interferes with Slow Detach Timeout
	//Mactrix additions end

		var frag = this._fragCurrent;
		if (frag) {
			logger.log('Video: resetting current frag load count as load was aborted');
			frag.loadCounter = 0;
			if (frag.loader) {
				frag.loader.abort();
			}
			this._fragCurrent = null;
		}
		this._fragPrevious = null;
		if (this._demuxer) {
			this._demuxer.destroy();
			this._demuxer = null;
		}
		this.state = State.STOPPED;
		this.timestampOffset = undefined;
	}

	tick() {
		this._ticks++;
		if (this._ticks === 1) {
			this.doTick();
			if (this._ticks > 1) {
				setTimeout(this.tick, 1);
			}
			this._ticks = 0;
		}
	}

	doTick() {
	//Mactrix additions start
	//we're stalling, and have not successfully finished a load for too long, emit a stream timeout
		if(this.media) {
			let media = this.media;
			let mediaBuffered = 0;
			mediaBuffered = media.buffered.length;

			if((this._streamTimeoutArmed || mediaBuffered === 0) && !this.forceStopFetching && ((!media.paused && !media.ended) || !this._playbackStarted)
			&& (this.hls.streamCoordinator._mainTimedOut || this.hls.streamCoordinator._audioTimedOut)) {
				logger.error(`stream has timed out`);
				this.hls.trigger(Event.ERROR, { type: ErrorTypes.NETWORK_ERROR, details: ErrorDetails.STREAM_TIMEOUT, fatal: true });
				return;
			}
		}
	//Mactrix additions end

		switch(this.state) {
		case State.ERROR:
		//don't do anything in error state to avoid breaking further ...
			break;
		case State.BUFFER_FLUSHING:
			// in buffer flushing state, reset fragLoadError counter
			this._fragLoadError = 0;
			break;
		case State.IDLE:
		// when this returns false there was an error and we shall return immediatly
		// from current tick
			if (!this._doTickIdle()) {
				return;
			}
			break;
		case State.WAITING_LEVEL:
			var level = this._levels[this._level];
		// check if playlist is already loaded
			if (level && level.details) {
				this.state = State.IDLE;
			}
			break;
		case State.FRAG_LOADING_WAITING_RETRY:
			var now = performance.now();
			var retryDate = this.retryDate;
		// if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
			if(!retryDate || (now >= retryDate) || (this.media && this.media.seeking)) {
				logger.log(`mediaController: retryDate reached, switch back to IDLE state`);
				this.state = State.IDLE;
			}
			break;
		case State.STOPPED:
			// Mactrix addition start
			if (this.hls._inSlowDetach ) {
				this._slowDetachTicks ++;
				if (this._slowDetachTicks > 10) {
					//The ticks are 100ms. The seek should take under a second to play out. Even setting
					//this at 1 doesn't seem to give false timeouts, so 10 should be very safe.
					logger.log('slow detach idle');
					this.hls._doCompleteSlowDetach();
				}
			}
			break;
			// Mactrix addition end
		case State.FRAG_LOADING:
		case State.PARSING:
		case State.PARSED:
		case State.ENDED:
			break;
		default:
			break;
		}
		// check buffer
		this._checkBuffer();
	}

	// Ironically the "idle" state is the one we do the most logic in it seems ....
	// NOTE: Maybe we could rather schedule a check for buffer length after half of the currently
	//       played segment, or on pause/play/seek instead of naively checking every 100ms?
	_doTickIdle() {
		const hls = this.hls;
		const config = hls.config;
		const media = this.media;

		// if video not attached AND
		// start fragment already requested OR start frag prefetch disable
		// exit loop
		// => if start level loaded and media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
		if ( this._levelLastLoaded !== undefined && !media && (this._startFragRequested || !config.startFragPrefetch) ) {
			return true;
		}

	// if we have not yet loaded any fragment, start loading from start position
		let pos;
		if(this._bufferBeforeSeekingTime !== undefined && this._bufferBeforeSeekingApplied === false) {
			logger.log('main: using bufferBeforeSeeking');
			this._bufferBeforeSeekingApplied = true;
			pos = this._bufferBeforeSeekingTime;
			this._fragPrevious = null;
		}
		else if (this._loadedMetadata && this._bufferBeforeSeekingTime === undefined) {
			pos = media.currentTime;
		}
		else {
			pos = this._nextLoadPosition;
		}
		// determine next load level
		const level = hls.nextLoadLevel;
		const levelInfo = this._levels[level];
		const levelBitrate = levelInfo.bitrate;
		let maxBufLen;

	// compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
		if (levelBitrate) {
			maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
		}
		else {
			maxBufLen = config.maxBufferLength;
		}
		maxBufLen = Math.min(maxBufLen, config.maxMaxBufferLength);

	// determine next candidate fragment to be loaded, based on current position and end of buffer position
	// ensure up to `config.maxMaxBufferLength` of buffer upfront

		const bufferInfo = BufferHelper.bufferInfo(this.mediaBuffer ? this.mediaBuffer : media, pos, 0);
		const bufferLen = bufferInfo.len;
	// Stay idle if we are still with buffer margins
		if (bufferLen >= maxBufLen && this._bufferBeforeSeekingApplied !== true) {
			//logger.log('stream-controller: Buffer full; do not queue');
			return true;
		}

	// if buffer length is less than maxBufLen try to load a new fragment ...
		logger.trace(`buffer length of ${bufferLen.toFixed(3)} is below max of ${maxBufLen.toFixed(3)}. checking for more payload ...`);

	// set next load level : this will trigger a playlist load if needed
		this._level = hls.nextLoadLevel = level;

		//stop emitting LEVEL_SELECTION_FINISHED here as we want to wait until after frag selection to update metrics
		//hls.trigger(Event.LEVEL_SELECTION_FINISHED);

		const levelDetails = levelInfo.details;
	// if level info not retrieved yet, switch state and wait for level retrieval
	// if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
	// a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
		if (typeof levelDetails === 'undefined' || levelDetails.live && this._levelLastLoaded !== level) {
			this.state = State.WAITING_LEVEL;
			return true;
		}

	// we just got done loading the final fragment, check if we need to finalize media stream
		let fragPrevious = this._fragPrevious;
		if (!levelDetails.live && fragPrevious && fragPrevious.sn === levelDetails.endSN) {

/* Mactrix replaced this...
		// if everything (almost) til the end is buffered, let's signal eos
		// we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference
		// using half frag duration should help cope with these cases.
		// also cope with almost zero last frag duration (max last frag duration with 200ms) refer to https://github.com/video-dev/hls.js/pull/657
		if (media.duration - Math.max(bufferInfo.end,fragPrevious.start) <= Math.max(0.2,fragPrevious.duration/2)) {
with ... */

		// Mactrix replacement start
		// This attempts to break the EOS issue internally with no overhead other than at near EOS
		// Not my preferred solution but at the curremt moment the currentTime can around a second different between runs so
		// a cleaner method is difficult.
			if (this._lastCurrentTime === media.currentTime) {
				this._endStallOffseter += 0.2;
				//hls.trigger(Event.ERROR, {type: ErrorTypes.MEDIA_ERROR, details: 'endcheck ' + this._endStallOffseter + ' ' + media.duration +
				//' ' + media.currentTime, fatal: false});
			}
			if ((media.duration - Math.max(bufferInfo.end, fragPrevious.start) <= Math.max(0.2, fragPrevious.duration / 2) + this._endStallOffseter)
			|| this._levels[this._level].deadFragList.length > 0 || this._levels[this._level].containsGaps) { //If we have gaps in the manifest this check isn't reliable
		// Mactrix replacement end

		// Finalize the media stream
				let data = {};
				if (this._altAudio) {
					data.type = 'video';
				}
				this.hls.trigger(Event.BUFFER_EOS, data);
				this.state = State.ENDED;
				this._endStallOffseter = 0; // Mactrix addition
				return true;
			}
		}

	// if we have the levelDetails for the selected variant, lets continue enrichen our stream (load keys/fragments or trigger EOS, etc..)
		return this._fetchPayloadOrEos(pos, bufferInfo, levelDetails);
	}

	_fetchPayloadOrEos(pos, bufferInfo, levelDetails) {
		const level = this._level;
		const fragments = levelDetails.fragments;
		const fragLen = fragments.length;

		// empty playlist
		if (fragLen === 0) {
			return false;
		}

		// find fragment index, contiguous with end of buffer position
		let start = fragments[0].start;
		let end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration;
		let bufferEnd = bufferInfo.end;
		let frag;

		if (levelDetails.initSegment && !levelDetails.initSegment.data) {
			frag = levelDetails.initSegment;
		}
		else {
			//Mactrix changes begin: disable for now, Don't think it's correct
			/*
			if(this.pdtDiff === undefined && this.initialPdt && this.hls.audioStreamController && this.hls.audioStreamController.initialPdt) {
				this.pdtDiff = this.initialPdt - this.hls.audioStreamController.initialPdt;

				if(this.pdtDiff < 0 && fragments.length > 1) {
					this._pdtAlign(fragments, levelDetails);
				}
			}
			*/
			//Mactrix changes end

			// in case of live playlist we need to ensure that requested position is not located before playlist start
			if (levelDetails.live) {
				let initialLiveManifestSize = this.config.initialLiveManifestSize;
				if(fragLen < initialLiveManifestSize) {
					logger.warn(`Can not start playback of a level, reason: not enough fragments ${fragLen} < ${initialLiveManifestSize}`);
					return false;
				}

			/* Mactrix remove: not doing this for now
				frag = this._ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen);
			*/

				// if it explicitely returns null don't load any fragment and exit function now
				if (frag === null) {
					return false;
				}
			}
			else {
				// VoD playlist: if bufferEnd before start of playlist, load first fragment
				if (bufferEnd < start) {
					frag = fragments[0];
				}
			}
		}
//Mactrix additions start
		if (this.forceStopFetching === true) {
			return true;
		}
//Mactrix additions end
		if (!frag) {
			let buffer = this.mediaBuffer;

			// After the buffer is created (which is after the initial frag(s) is/are buffered) mediabuffer should be
			// correct for the renditions and in mux cases , but the way it is set should be investigated
			//if (this._altAudio) {
			//	if (this.videoBuffer && buffer !== this.videoBuffer) {
			//		console.log(`corrected buffer before findFragment${this.videoBuffer}`);
			//		buffer = this.videoBuffer;
			//	}
			//}

			let findFragResults = this._findFragment(start,
				this._fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails, pos, this._clearFragPrevious, buffer);
			frag = findFragResults.frag;
			this._clearFragPrevious = findFragResults.clearFragPrevious;
			this._fragPrevious = findFragResults.fragPrevious;
		}

		if(frag) {
			//try to level switch around a gap
			//we'll stop switching if
			//- we run out of variants to try
			//- we're too close to the end of the buffer
			//- the level controller is currently in the middle of dropping dead frags
			if(frag.gap && this._gapCycleBase !== this._level && (this._fragPrevious && frag.sn !== this._fragPrevious.sn + 1)) {
				if(this._gapCycleBase === undefined) {
					this._gapCycleBase = this._level;
				}

				if(this.hls.levelController.tryNextVariant(this._level, false)) {
					this.state = State.WAITING_LEVEL;
					return true;
				}
			}
			if(!this._fragPrevious || !this._fragPrevious.pdt || !frag.pdt || this._fragPrevious.pdt !== frag.pdt) {
			/* Mactrix changes begin: flush the next buffered range if the current buffered range will intersect with it
				let media = this.media;

				if(media && media.buffered.length > 1) {
					let i;

					for(i = 0; i < media.buffered.length; i++) {
						if (bufferEnd + 0.2 + frag.duration >= media.buffered.start(i) && bufferEnd + 0.2 + frag.duration < media.buffered.end(i)) {
							//Does this have to be the end of the buffered range, we could just flush start(i) + frag.duration?
							//Don't want to run into manifest time v ts time issues and having to do a .2 fudge so leaving it at end(i)
							this.hls.trigger(Event.BUFFER_FLUSHING, {startOffset: media.buffered.start(i), endOffset: media.buffered.end(i)});
							break;
						}
					}
				}
			*/
				this.hls.trigger(Event.FRAG_START_FOUND, { startPdt: frag.pdt });
				return this._loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd);
			}
		}

		return true;
	}

//Mactrix changes begin: align frags to start from the same pdt when starting a stream
	_pdtAlign(fragments, trackDetails) {
	//variance is 1/2 a manifest duration
	//using frag current here always assumes that the video will load first .. is this true??
	//let variance = this.hls.streamController.fragCurrent.manifestDuration * 500;
	//just base this off the first frag audio duration ... not right but should be close enough
		let variance = fragments[0].manifestDuration * 500;
		let i;
		let pdtToAlignTo;
		let controller;

		if(fragments[0].type === 'main') {
			pdtToAlignTo = this.hls.audioStreamController.initialPdt;
			controller = this;
		}
		else {
			pdtToAlignTo = this.initialPdt;
			controller = this.hls.audioStreamController;
		}

	//audio is behind video, drop frags until we are inside the 1/2 frag variance
	//if we can't sync, we'll leave one frag in the chamber ... we'll be out of sync ... not much else we can do!
		for(i = 0; fragments.length > 1 && fragments[0].pdt < pdtToAlignTo - variance; i++) {
			controller.initialPdt += fragments[0].manifestDuration * 1000;
			fragments.splice(0, 1);
		}

		if(i > 0) {
		//adjust the metadata of the remaining frags
			fragments[0].start = 0;
			fragments[0].index = 0;
			fragments[0].pdt = controller.initialPdt;
			fragments[0].sn -= i;
			trackDetails.endSN -= i;

			for(i = 1; i < fragments.length; i++) {
				fragments[i].start = fragments[i - 1].start + fragments[i - 1].duration;
				fragments[i].pdt = fragments[i - 1].pdt + fragments[i - 1].manifestDuration * 1000;
				fragments[i].index = i;
				fragments[i].sn = fragments[i - 1].sn + 1;
			}
		}
	}
//Mactrix changes end

//Mactrix changes begin: use a sub optimal pdt linear search until binary search is fixed
	_linearSearch(fragments, fragPrevious, millisTarget, snapToNearestFrag) {
		let frag;

		for ( let i = 0; i < fragments.length; i++) {
			let millisCurrent = fragments[i].pdt;
			let millisNext = millisCurrent + fragments[i].manifestDuration * 1000;

			if(millisNext <= millisTarget) {
				continue;
			}

			let millisMidpoint = (millisCurrent + millisNext) / 2;

			if(millisMidpoint < millisTarget && snapToNearestFrag === true) {
			//logger.log(`_linearSearch: millisMidpoint < millisTarget - ${(millisMidpoint - this.initialPdt)} : ${(millisTarget - this.initialPdt)}`);
				continue;
			}

			if(fragPrevious && fragPrevious.pdt && fragPrevious.pdt === fragments[i].pdt) {
				continue;
			}
/*
		if (fragPrevious) {
			//allow 1/2 a manifest duration to account for any pdt errors
			let variance = (fragments[i].manifestDuration * 1000) / 2;

			if(fragPrevious.pdt >= fragments[i].pdt - variance && fragPrevious.pdt <= fragments[i].pdt + variance) {
				console.log('@@ _linearSearch frag falls within variance, treating as duplicate');
				continue;
			}
		}
*/
		//logger.log(`_linearSearch: name: ${fragments[i].relurl} millisCurrent: ${(millisCurrent - this.initialPdt)} millisTarget: ${(millisTarget - this.initialPdt)}`);

			frag = fragments[i];
			break;
		}

		return frag;
	}
//Mactrix changes

	_ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments/*, fragLen*/) {
		/* Mactrix line removed - variable no longer used in this function
		const config = this.hls.config;
		*/
		const media = this.media;

		let frag;

	// check if requested position is within seekable boundaries :
	//logger.log(`start/pos/bufEnd/seeking:${start.toFixed(3)}/${pos.toFixed(3)}/${bufferEnd.toFixed(3)}/${this.media.seeking}`);

	/*	let maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration
			: config.liveMaxLatencyDurationCount * levelDetails.targetduration;
*/
	/* Mactrix lines removed - we want the program invoking BAM HLS to choose how to handle this situation
	if (bufferEnd < Math.max(start-config.maxFragLookUpTolerance, end - maxLatency)) {
		let liveSyncPosition = this.liveSyncPosition = this.computeLivePosition(start, levelDetails);
		logger.log(`buffer end: ${bufferEnd.toFixed(3)} is located too far from the end of live sliding playlist, reset currentTime to : ${liveSyncPosition.toFixed(3)}`);
		bufferEnd = liveSyncPosition;
		if (media && media.readyState && media.duration > liveSyncPosition) {
		  media.currentTime = liveSyncPosition;
		}
	}
	*/

	// if end of buffer greater than live edge, don't load any fragment
	// this could happen if live playlist intermittently slides in the past.
	// level 1 loaded [182580161,182580167]
	// level 1 loaded [182580162,182580169]
	// Loading 182580168 of [182580162 ,182580169],level 1 ..
	// Loading 182580169 of [182580162 ,182580169],level 1 ..
	// level 1 loaded [182580162,182580168] <============= here we should have bufferEnd > end. in that case break to avoid reloading 182580168
	// level 1 loaded [182580164,182580171]
	//
	// don't return null in case media not loaded yet (readystate === 0)
		if (levelDetails.PTSKnown && bufferEnd > end && media && media.readyState) {
			return null;
		}

		if (this._startFragRequested && !levelDetails.PTSKnown) {
			/*
				we are switching level on live playlist, but we don't have any PTS info for that quality level ...
				try to load frag matching with next SN.
				even if SN are not synchronized between playlists, loading this frag will help us
				compute playlist sliding and find the right one after in case it was not the right consecutive one
			*/
			if (fragPrevious) {
//Mactrix changes begin: select the frag based on the pdt if it exists
				if(this._selectByPdt && fragPrevious.pdt !== undefined && fragments[0].pdt !== undefined) {

				/* searchByPdt is used by the binary-search
					let searchByPdt = (candidate) => {
				//
				//	6.2.  Server Responsibilities

				//	6.2.4.  Providing Variant Streams

				//	If any Media Playlist in a Master Playlist contains an EXT-X
				//	-PROGRAM-DATE-TIME tag, then all Media Playlists in that Master
				//	Playlist MUST contain EXT-X-PROGRAM-DATE-TIME tags with consistent
				//	mappings of date and time to media timestamps.
				//
						if(candidate.pdt !== undefined) {
					//we need to search for the candidate which is the first chunk after bufferEnd
					//As long as the error between bufferEnd(transport stream time) and the candidate
					//pdt (manifest time) is less than 1/2 a chunk duration (which it should be!) then
					//we don't need to account for this error since the pdt tolerance of 1/2 a chunk should cover it
							let millisDuration = candidate.manifestDuration * 1000;
							let millisCurrent = candidate.pdt;
							let millisNext = millisCurrent + millisDuration;
							let millisTarget = fragPrevious.pdt + fragPrevious.manifestDuration * 1000;

							if (millisNext <= millisTarget) {
								return 1;
							}
							else {
								let midpointMillis = (millisCurrent + millisNext) / 2;

								if(midpointMillis >= millisTarget) {
									if(midpointMillis - millisTarget < (millisDuration)) {
								//this.previousPdt = candidate.pdt;
								//logger.log(`_ensureFragmentAtLivePoint mp > mt searchByPdt - sn: ${candidate.sn} pdt: ${candidate.pdt} name: ${candidate.relurl} mpm ${midpointMillis} mt: ${millisTarget} md: ${millisDuration}`);
										return 0;
									}
									else {
										return -1;
									}
								}
								else {
							//this.previousPdt = candidate.pdt;
							//logger.log(`_ensureFragmentAtLivePoint mp < mt searchByPdt - sn: ${candidate.sn} pdt: ${candidate.pdt} name: ${candidate.relurl}`);

									return 1;
								}
							}
						}
						else {
					//if the previous frag has a pdt then all candidates must have a pdt
							logger.warn(`_ensureFragmentAtLivePoint fragPrevious has a pdt but candidate frag does not!`);
					//set error and fall back to media sequence
							return 0;
						}
					};

					*/

			//frag = BinarySearch.search(fragments, searchByPdt);

			//use sub optimal linear search until binary search can be fixed
			//once binary search is fixed we can enable pdts across all browsers not just Safari
					frag = this._linearSearch(fragments, fragPrevious, fragPrevious.pdt + fragPrevious.manifestDuration * 1000, true);
				}
				else {
//Mactrix changes end
					var targetSN = fragPrevious.sn + 1;
					if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
						frag = fragments[targetSN - levelDetails.startSN];

//Mactrix changes begin
						if(fragPrevious.pdt && frag.pdt && fragPrevious.pdt === frag.pdt) {
					//the selector choose the same frag, either we are at the end of the list ... set it to null
					//or what we really want is the next frag
							if(frag.index < fragments.length - 1) {
								frag = fragments[frag.index + 1];
							}
							else {
								frag = undefined;
							}
						}
//Mactrix changes end
						logger.log(`live playlist, switching playlist, load frag with next SN: ${frag.sn}`);
					}
//Mactrix changes begin
				}
//Mactrix changes end
			}
			else {
/*Mactrix remove: Only guess when we have no previous frag
		  logger.log('**_ensureFragmentAtLivePoint No frag previous!');
	  }
	  if (!frag) {
*/
		/* we have no idea about which fragment should be loaded.
		   so let's load mid fragment. it will help computing playlist sliding and find the right one
		*/
/*
		console.log('@@ live playlist, switching playlist, unknown, load middle frag');
		frag = fragments[Math.min(fragLen - 1, Math.round(fragLen / 2))];
		logger.log(`live playlist, switching playlist, unknown, load middle frag : ${frag.sn}`);
*/
			}
		}
		return frag;
	}

  //Mactrix changes begin

  //this is done by start time .... add a pdt version if required
	bufferEndToManifestTimeBrute(fragments, bufferEnd) {
		let myBufferEnd = bufferEnd;
		let count = 0;

		for(count = 0; count < fragments.length; count++) {
		//we will clamp the bufferEnd to the startTime of the frag if it is within
		//20% of the manifestDuration
			let variance = fragments[count].manifestDuration / 5;

			if(myBufferEnd > fragments[count].start - variance && myBufferEnd < fragments[count].start + variance) {
				myBufferEnd = fragments[count].start;
				break;
			}
		}

		return myBufferEnd;
	}

	bufferEndToManifestTimeViaPdt(fragments, bufferEnd, targetDuration) {
	//this should give an approx index into the frags array for the frag at the end of the buffered range
	//the closer the targetDuration to the average frag duration the more accurate.
		let index = Math.round(bufferEnd / targetDuration);
		let myBufferEnd = bufferEnd;

		if(index >= 0 && index < fragments.length) {
		//we will clamp the bufferEnd to the startTime of the frag if it is within
		//20% of the manifestDuration
			let variance = (fragments[index].manifestDuration / 5) * 1000;
			let basePdt = 0;

		//should really pass this in
			if(fragments[0].type === 'main') {
				basePdt = new Date(this.hls.streamCoordinator._mainBasePdt).getTime();
			}
			else {
				basePdt = new Date(this.hls.streamCoordinator._audioBasePdt).getTime();
			}

		//convert to pdt
			myBufferEnd = basePdt + bufferEnd * 1000;

			if(myBufferEnd > fragments[index].pdt + variance) {
				while(index < fragments.length && myBufferEnd > fragments[index].pdt + variance) {
				//console.log('## fragment[index] too early, moving forward');
					index++;
				}

				if(index >= fragments.length) {
					index = fragments.length - 1;
				}
			}
			else {
				while(index >= 0 && myBufferEnd < fragments[index].pdt - variance) {
				//console.log('## fragment[index] too late, moving backward');
					index--;
				}

				if(index < 0) {
					index = 0;
				}
			}

		//console.log('## bufferEnd: ' + myBufferEnd + ' manifestEnd: ' + fragments[index].pdt);
			myBufferEnd = fragments[index].start;
		}
		else {
			if(index === fragments.length) {
				myBufferEnd = fragments[fragments.length - 1].start + fragments[fragments.length - 1].manifestDuration;
			}
			else {
			//logger.warn(`## streamController: index out of range, bufferEnd of ${myBufferEnd} remains unchanged`);
			}
		}

		return myBufferEnd;
	}

	bufferEndToManifestTimeViaStart(fragments, bufferEnd, targetDuration) {
	//this should give an approx index into the frags array for the frag at the end of the buffered range
	//the closer the targetDuration to the average frag duration the more accurate.
		let index = Math.round(bufferEnd / targetDuration);
		let myBufferEnd = bufferEnd;
		let offset = -fragments[0].start;

		if(index >= 0 && index < fragments.length) {
		//we will clamp the bufferEnd to the startTime of the frag if it is within
		//20% of the manifestDuration
			let variance = fragments[index].manifestDuration / 5;

			if(myBufferEnd > (fragments[index].start + offset) + variance) {
				while(index < fragments.length && myBufferEnd > (fragments[index].start + offset) + variance) {
				//console.log('## fragment[index] too early, moving forward');
					index++;
				}

				if(index >= fragments.length) {
					index = fragments.length - 1;
				}
			}
			else {
				while(index >= 0 && myBufferEnd < (fragments[index].start + offset) - variance) {
				//console.log('## fragment[index] too late, moving backward');
					index--;
				}

				if(index < 0) {
					index = 0;
				}
			}

		//console.log('## bufferEnd: ' + myBufferEnd + ' manifestEnd: ' + (fragments[index].start + offset));

			myBufferEnd = fragments[index].start + offset;

		//
			//this could now be used to pick the next fragment, since the frag we want is the one after bufferEnd - test this
		//	nextFrag = index < fragments.length - 1 ? fragments[index + 1] : null;
		//

		}
		else {
			if(index === fragments.length) {
				myBufferEnd = fragments[fragments.length - 1].start + fragments[fragments.length - 1].manifestDuration;
			}
			else {
			//logger.warn(`## streamController: index out of range, bufferEnd of ${myBufferEnd} remains unchanged`);
			}
		}

		return myBufferEnd;
	}

	bufferEndToManifestTime(fragments, bufferEnd, targetDuration) {
		let myBufferEnd = bufferEnd;

		if(this.hls.streamCoordinator._mainBasePdt) {
			myBufferEnd = this.bufferEndToManifestTimeViaPdt(fragments, bufferEnd, targetDuration);
		}
		else {
			if(fragments[0].start === 0) {
			//not correct with a non-zero offset ... investigate
				myBufferEnd = this.bufferEndToManifestTimeViaStart(fragments, bufferEnd, targetDuration);
			}
			else {
			//use the brute force version in the non-pdt case until until bufferEndToManifestTimeViaStart is fixed
				myBufferEnd = this.bufferEndToManifestTimeBrute(fragments, bufferEnd);
			}
		}

		return myBufferEnd;
	}
//Mactrix changes end

	//Used by both controllers, and ultimately might be better in another module with increased isolation
	//Return value have been changed from a simple frag to a structure so values can be passed back without
	//changing passed in params
	_findFragment(start, fragPreviousIn, fragLen, fragments, desiredTime, end, levelDetails, pos, clearFragPreviousIn, media) {
		const config = this.hls.config;
		let frag = null;
		let foundFrag = false;
		let maxFragLookUpTolerance = config.maxFragLookUpTolerance;
		let bestCandidate = null;
		let fragPrevious = fragPreviousIn;
		let clearFragPrevious = clearFragPreviousIn;

		let foundNext = false;
		let foundBinary = false;
		let previouslyNoPrevious = false;
		let noNewFrag = false;
		let endOfPlaylist = false;
		let foundSwitch = false;
		let foundPdtNext = false;

		if ( fragPrevious) {
			//this.media.currentTime was changed to pos here
			if(	((!BufferHelper.isBuffered(media, pos ) && ((fragPrevious.start > pos) || (fragPrevious.start + (levelDetails.targetduration * 2)) < pos))
				|| clearFragPrevious)
			) {
			//got it wrong, try again
				if (fragPrevious.type !== 'audio' || this.isThereAnAudioGap(pos, false) !== undefined) {
					logger.log(`_findFragment: Clearing fragPrevious for ${fragPrevious.type}`);
					fragPrevious = null;
					clearFragPrevious = false;
				}
			}
		}
		else {
			previouslyNoPrevious = true;
		}

//Mactrix changes begin
	//don't do this while seeking .... we shouldn't be searching for fragments while seeking anyway!! problem for another day.
		if(!this.hls.media.seeking) {
			//map the bufferEnd which is in transport stream time to it's equivalent manifest time - disabling for now, still problematic (#770)
			//bufferEnd = this.bufferEndToManifestTime(fragments, bufferEnd, levelDetails.targetduration);
		}
//Mactrix changes end

		let index;
		if(fragPrevious) {
			index = fragments.findIndex((element) => {
				return element.sn === fragPrevious.sn;
			});
		}

		const fragNext = fragPrevious ? fragments[index + 1] : undefined;

		//if (fragNext) {
		//	logger.log(`Potential fragNext.sn ${fragNext.sn} bufferEnd ${bufferEnd} end ${end}`);
		//}

		let fragmentWithinToleranceTest = (candidate) => {
		// offset should be within fragment boundary - config.maxFragLookUpTolerance
		// this is to cope with situations like
		// desiredTime = 9.991
		// frag[Ø] : [0,10]
		// frag[1] : [10,20]
		// desiredTime is within frag[0] range ... although what we are expecting is to return frag[1] here
		//              frag start               frag start+duration
		//                  |-----------------------------|
		//              <--->                         <--->
		//  ...--------><-----------------------------><---------....
		// previous frag         matching fragment         next frag
		//  return -1             return 0                 return 1
		//logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${desiredTime}`);
		// Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
			let candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.manifestDuration);
			if (candidate.start + candidate.manifestDuration - candidateLookupTolerance <= desiredTime) {
				bestCandidate = candidate;
				return 1;
			} // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
			else if (candidate.start - candidateLookupTolerance > desiredTime && candidate.start) {
				bestCandidate = candidate;
				return -1;
			}
			return 0;
		};

		if (desiredTime < end) {
//Mactrix changes begin
			if (this._selectByPdt && this.initialPdt !== undefined/*fragPrevious && fragPrevious.pdt*//*fragNext && fragNext.pdt*/) {
				/*
					6.2.  Server Responsibilities

					6.2.4.  Providing Variant Streams

					If any Media Playlist in a Master Playlist contains an EXT-X
					-PROGRAM-DATE-TIME tag, then all Media Playlists in that Master
					Playlist MUST contain EXT-X-PROGRAM-DATE-TIME tags with consistent
					mappings of date and time to media timestamps.
				*/

				/* mactrix: searchByPdt is not used at the moment, because binary search.
				let searchByPdt = (candidate) => {

				if(candidate.pdt !== undefined) {
					//we need to search for the candidate which is the first chunk after bufferEnd
					//As long as the error between bufferEnd(transport stream time) and the candidate
					//pdt (manifest time) is less than 1/2 a chunk duration (which it should be!) then
					//we don't need to account for this error since the pdt tolerance of 1/2 a chunk should cover it
					let millisTolerance = 0;//200;
					let millisDuration = candidate.manifestDuration * 1000;
					let millisCurrent = candidate.pdt - this.initialPdt;
					let millisNext = millisCurrent + millisDuration;
					let millisTarget = bufferEnd * 1000 - millisTolerance;

					if (millisNext <= millisTarget ) {
						return 1;
					}
					else {
						//due to the fact that millisTarget is in transport stream time
						//we can get a false positive when millisTarget is slightly less than millisNext
						//when this occurs we want the next chunk
						//if (this.previousPdt === candidate.pdt) {
						//	return 1;
						//}

						let midpointMillis = (millisCurrent + millisNext) / 2;

						if(midpointMillis >= millisTarget) {
							if(midpointMillis - millisTarget < millisDuration) {
								//this.previousPdt = candidate.pdt;
								//logger.log(`**_findFragment mp > mt searchByPdt - sn: ${candidate.sn} pdt: ${millisCurrent} name: ${candidate.relurl} mpm ${midpointMillis} mt: ${millisTarget} md: ${millisDuration}`);
								return 0;
							}
							else {
								return -1;
							}
						}
						else {
							//due to the fact that millisTarget is in transport stream time
							//we can get a false positive when millisTarget is slightly less than millisNext
							//when this occurs we want the next chunk
							//if (this.previousPdt === candidate.pdt) {
							//	logger.log(`**_findFragment fp searchByPdt - sn: ${candidate.sn} pdt: ${candidate.pdt} name: ${candidate.relurl}`);
							//	return 1;
							//} else {
							//	this.previousPdt = candidate.pdt;
							//	logger.log(`**_findFragment mp < mt searchByPdt - sn: ${candidate.sn} pdt: ${candidate.pdt} name: ${candidate.relurl}`);
							//	return 0;
							return 1;
							//}
						}
					}
				}
				else {
					//if the previous frag has a pdt then all candidates must have a pdt
					logger.warn(`_findFragment fragPrevious has a pdt but candidate frag does not!`);
					return 0;
				}
			};
		*/

		//if(fragNext && searchByPdt(fragNext) === 0) {
		//	console.log('_findFragment: searchByPdt');
		//	foundFrag = fragNext;
		//} else {
			//foundFrag = BinarySearch.search(fragments, searchByPdt);

			//use sub optimal linear search until binary search can be fixed
			//once binary search is fixed we can enable pdts across all browsers not just Safari
				let millisTolerance = 0;//200;
				foundFrag = this._linearSearch(fragments, fragPrevious, this.initialPdt + (desiredTime * 1000 - millisTolerance), false);
				logger.log(`_findFragment: _linearSearch pos:${pos}`);
		//}
			}
			else {
//Mactrix changes end
				maxFragLookUpTolerance = 0.2; //Mactrix line added, turn on frag tolerance for next frag test
				if (desiredTime > end - maxFragLookUpTolerance) {
					maxFragLookUpTolerance = 0;
				}

			// Prefer the next fragment if it's within tolerance
				if (fragNext && !fragmentWithinToleranceTest(fragNext)) {
					foundFrag = fragNext;
					foundNext = true;
					logger.log(`_findFragment: Picked next frag`);
				}
				else {
					maxFragLookUpTolerance = 0; //Mactrix line added, turn off frag tolerance
					foundFrag = BinarySearch.search(fragments, fragmentWithinToleranceTest);
					//logger.log(`_findFragment: BinarySearch pos:${pos} desiredTime:${desiredTime}`);

					//if we get null here it means that we fallen into a virutal hole in the manifest
					//we shouldn't really be getting null here, this is caused by a mismatch between transport stream time
					//and manifest time, bufferEndToManifestTime isn't really viable, this is probably the best we can do.
					if(foundFrag === null) {
						//logger.log(`_findFragment: Going for the second best choice`);
						//go with the best candidate, the following block should adjust it if it's not quite right
						foundFrag = bestCandidate;
					}

					foundBinary = true;
				}

				maxFragLookUpTolerance = 0; //Mactrix line added, turn off frag tolerance
		//Mactrix changes begin
				if(fragPrevious && foundFrag && fragPrevious.pdt && foundFrag.pdt) {
					let expectedTime = this.hls.streamCoordinator.basePdt.getTime() + (desiredTime * 1000);
					let variance = fragPrevious.manifestDuration * 500; //variance is 1/2 a manifest duration

					//if the frag is within +/- 1/2 a fragPrevious manifestDuration, then accept it

					if(foundFrag.pdt < expectedTime - variance) {
						while(foundFrag.index < fragments.length - 1 && foundFrag.pdt < expectedTime - variance) {
							foundFrag = fragments[foundFrag.index + 1];
						}

						//check to make sure it's valid
						if(levelDetails.live && foundFrag.index === fragments.length - 1 && foundFrag.pdt < expectedTime - variance && foundFrag.type === 'main') {
							//wait for a manifest refresh so we can pick up the next chunk
							if(levelDetails.endSN !== levelDetails.originalEndSN && this._gapCycleBase !== this._level) {
								if(this._gapCycleBase === undefined) {
									this._gapCycleBase = this._level;
								}

								if(this.hls.levelController.tryNextVariant(this._level, false)) {
									this.state = State.WAITING_LEVEL;
									foundSwitch = true;
								}
							}
							foundFrag = undefined;
						}
					}
					else if(foundFrag.pdt - foundFrag.gap > expectedTime + variance) {
						while(foundFrag.index > 0 && foundFrag.pdt > expectedTime + variance) {
							foundFrag = fragments[foundFrag.index - 1];
						}
						//check to make sure it's valid
						if(foundFrag.index === 0 && foundFrag.pdt > expectedTime + variance) {
							//we have fallen off the window ... this is the best we can do
							//foundFrag = undefined;
						}
					}
				}
				else if(foundFrag) {
					let expectedTime = 0;

					//convert pos to a pdt
					if(foundFrag.type === 'audio') {
						expectedTime = this.hls.audioStreamController.initialPdt + (desiredTime * 1000);
					}
					else {
						expectedTime = this.hls.streamController.initialPdt + (desiredTime * 1000);
					}

					//console.log('# no frag prev, using position: ' + expectedTime);

					if(foundFrag.pdt + foundFrag.manifestDuration * 1000 < expectedTime) {
						//console.log('# foundFrag too early, winding forward');

						//foundFrag is too early, wind forward until we find it
						while(foundFrag.index < fragments.length - 1 && foundFrag.pdt + foundFrag.manifestDuration * 1000 < expectedTime) {
							foundFrag = fragments[foundFrag.index + 1];
						}

						//check to make sure it's valid
						if(levelDetails.live && foundFrag.index === fragments.length - 1 && foundFrag.pdt + foundFrag.manifestDuration * 1000 < expectedTime && foundFrag.type === 'main') {
							//wait for a manifest refresh so we can pick up the next chunk
							if(levelDetails.endSN !== levelDetails.originalEndSN && this._gapCycleBase !== this._level) {
								if(this._gapCycleBase === undefined) {
									this._gapCycleBase = this._level;
								}

								if(this.hls.levelController.tryNextVariant(this._level, false)) {
									this.state = State.WAITING_LEVEL;
								}
							}

							foundFrag = undefined;
						}
					}
					else if(foundFrag.pdt > expectedTime) {
						//console.log('# foundFrag too late, winding backward');

						//foundFrag is too early, wind backward until we find it
						while(foundFrag.index > 0 && foundFrag.pdt > expectedTime) {
							foundFrag = fragments[foundFrag.index - 1];
						}

						//check to make sure it's valid
						if(foundFrag.index === 0 && foundFrag.pdt > expectedTime) {
							//we have fallen off the window ... this is the best we can do
							//foundFrag = undefined;
						}
					}
				}
			}
//Mactrix changes end
		}
		else {

			endOfPlaylist = true;
			// reach end of playlist
			foundFrag = fragments[fragLen - 1];
			if(levelDetails.endSN !== levelDetails.originalEndSN && this._gapCycleBase !== this._level && foundFrag.type === 'main') {
				if(this._gapCycleBase === undefined) {
					this._gapCycleBase = this._level;
				}

				if(this.hls.levelController.tryNextVariant(this._level, false)) {
					this.state = State.WAITING_LEVEL;
					foundSwitch = true;
				}
				foundFrag = undefined;
			}
			else if(fragPrevious && fragPrevious.pdt) {
				let expectedTime = fragPrevious.pdt + fragPrevious.manifestDuration * 1000;
				let variance = fragPrevious.manifestDuration * 500; //variance is 1/2 a manifest duration

				if(foundFrag.pdt > expectedTime + variance) {
					while(foundFrag.index > 0 && foundFrag.pdt > expectedTime + variance) {
						foundFrag = fragments[foundFrag.index - 1];
					}
					//check to make sure it's valid
					if(foundFrag.index === 0 && foundFrag.pdt > expectedTime + variance) {
						//we have fallen off the window
						foundFrag = undefined;
					}

					foundPdtNext = true;
				}
				else {
					foundFrag = undefined;
				}
			}
			else {
				foundFrag = undefined;
			}
		}

		//Mactrix: I don't think we need this block when using muxjs (EXCEPT TO SET frag = foundFrag, and the
		//		   Mactrix workaround at the end of the block), since muxjs keeps a GOP cache
		//		   and uses it to find a the best candidate for GOP fusion, if it can't find one it
		//		   will drop all frames before the keyframe, then extend the key frame duration by the
		//		   amount of frames dropped. The frag.dropped parameter is always set to false
		//		   in muxjs-inline anyway.
		if (foundFrag) {
		//Mactrix additions start
		//when we fix sync some frags will end up with negative start time
		//we want to skip these as trying to load these will guarantee a sync failure and Chrome doesn't like negative timestamps in the buffer
			if(foundFrag.start < 0) {
				foundFrag = fragments[foundFrag.index + 1];
			}
		//Mactrix additions end
			frag = foundFrag;

			//const curSNIdx = frag.sn - levelDetails.startSN;
			/*
			const sameLevel = fragPrevious && frag.level === fragPrevious.level;
			const prevFrag = fragments[curSNIdx - 1];
		 	const nextFrag = fragments[curSNIdx + 1];
			//logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
			if (sameLevel && frag.sn === fragPrevious.sn) {
				if (frag.sn < levelDetails.endSN) {
					let deltaPTS = fragPrevious.deltaPTS;
					// if there is a significant delta between audio and video, larger than max allowed hole,
					// and if previous remuxed fragment did not start with a keyframe. (fragPrevious.dropped)
					// let's try to load previous fragment again to get last keyframe
					// then we will reload again current fragment (that way we should be able to fill the buffer hole ...)
					if (deltaPTS && deltaPTS > config.maxBufferHole && fragPrevious.dropped && curSNIdx) {
						frag = prevFrag;
						logger.warn(`SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this`);
						// decrement previous frag load counter to avoid frag loop loading error when next fragment will get reloaded
						fragPrevious.loadCounter--;
					}
					else {
						frag = nextFrag;
						logger.log(`SN just loaded, load next one: ${frag.sn}`);
					}
				}
				else {
					frag = null;
				}
			}
			else if (frag.dropped && !sameLevel) {
				// Only backtrack a max of 1 consecutive fragment to prevent sliding back too far when little or no frags start with keyframes
				if (nextFrag && nextFrag.backtracked) {
					logger.warn(`Already backtracked from fragment ${curSNIdx + 1}, will not backtrack to fragment ${curSNIdx}. Loading fragment ${curSNIdx + 1}`);
					frag = nextFrag;
			}
			else {
				// If a fragment has dropped frames and it's in a different level/sequence, load the previous fragment to try and find the keyframe
				// Reset the dropped count now since it won't be reset until we parse the fragment again,
				// which prevents infinite backtracking on the same segment
				logger.warn('Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe');
				frag.dropped = 0;
				if (prevFrag) {
					if (prevFrag.loadCounter) {
						prevFrag.loadCounter--;
					}
					frag = prevFrag;
				}
				else {
					frag = null;
				}
			}
		}
		*/

			//Backtrack to previous frag if we're just before the start of a buffered range
			//If this has happened, HlsJs selected the wrong fragment previously, and needs to be corrected

			//this.media.currentTime was changed to pos here

			if(fragPrevious && media && media.buffered.length && fragments[fragPrevious.sn - levelDetails.startSN - 1] && pos !== 0) {
			//we shouldn't need to do this at currentTime = 0, as we'll be automatically moved to the start of the first frag
				for(let i = 0; i < media.buffered.length; i++) {
					if (pos < media.buffered.start(i) && frag.start > pos &&
					pos > media.buffered.start(i) - (levelDetails.averagetargetduration * 1.1) &&
					(i === 0 || media.buffered.start(i) - media.buffered.end(i - 1) > levelDetails.averagetargetduration / 2) &&
					fragments[fragPrevious.sn - levelDetails.startSN - 1].start > pos - levelDetails.averagetargetduration) {
						logger.warn(`${fragPrevious.type} buffer too far forward, backtracking to fill buffer hole`);
						frag = fragments[fragPrevious.sn - levelDetails.startSN - 1];
					}
				}
			}

			//if all else fails to get the controller to progress through the manifest, force it onto the next frag
			//unless there's no next frag to go to, in which case return undefined to avoid frag loop errors
			if(fragPrevious && frag.sn === fragPrevious.sn) {
				if(fragments[frag.index + 1]) {
					frag = fragments[frag.index + 1];
				}
				else {
					frag = undefined;
				}
			}
		}
		else {
			noNewFrag = true;
		}


		//if (!noNewFrag && !foundNext && !foundBinary && !foundPdtNext) {
		//	logger.log(`_findFragment not sure how this one was found`);
		//}
		//logger.log(`_findfragment END foundNext:${foundNext} foundBinary:${foundBinary} foundSwitch:${foundSwitch} endOfPlaylist:${endOfPlaylist} noNewFrag:${noNewFrag} previouslyNoPrevious:${previouslyNoPrevious}`);
		//if (fragPrevious) {
		//	logger.log(`_findfragment END type:${fragPrevious.type}`);
		//}

		let results = {
			frag,
			fragPrevious,
			clearFragPrevious,
			foundNext,
			foundBinary,
			foundPdtNext,
			foundSwitch,
			endOfPlaylist,
			noNewFrag,
			previouslyNoPrevious,
		};

		return results;
	}

	_loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd) {
		const hls = this.hls;
		const config = hls.config;

	//logger.log('loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
		if ((frag.decryptdata && frag.decryptdata.uri != null) && (frag.decryptdata.key == null)) {
			logger.log(`Main loading key for ${frag.sn} of [${levelDetails.startSN} ,${levelDetails.endSN}],level ${level}`);
			this.state = State.KEY_LOADING;

			//Not the best logic, but with the way the selector works it needs to do again if there's a key needed
			//Might look into changing the selector concept at a latter date to avoid the double selecting
			if (this._bufferBeforeSeekingApplied === true) {
				this._bufferBeforeSeekingApplied = false;
				logger.log('_loadFragmentOrKey: bufferBeforeSeeking key reset');
			}
			hls.trigger(Event.KEY_LOADING, { frag: frag });
		}
		else { //Mactrix remove line: I don't see the point in running the main loop twice for key load and frag parse ... doing it in the one call
			/*
			logger.log(`Loading ${frag.sn} of [${levelDetails.startSN} ,${levelDetails.endSN}],level ${level}, currentTime:${pos.toFixed(3)},bufferEnd:${bufferEnd.toFixed(3)}`);
			*/

			//Mactrix changes begin, handle cases where pos/bufferEnd are null or undefined
			//TODO: fix what is causing pos to be null/undefined, as that shouldn't be happening
			try {
				if(!this.hls.browIE && !this.hls.browTizen2) {
				//Number.isFinite() isn't supported in IE or Tizen 2, and global isFinite() returns true on null, which we don't want
					if(Number.isFinite(pos) && Number.isFinite(bufferEnd)) {
						logger.log(`Main loading ${frag.sn} of [${levelDetails.startSN} ,${levelDetails.endSN}],level ${level}, pos:${pos.toFixed(3)},bufferEnd:${bufferEnd.toFixed(3)}`);
					}
					else {
						logger.log(`Main loading ${frag.sn} of [${levelDetails.startSN} ,${levelDetails.endSN}],level ${level}, pos:${pos},bufferEnd:${bufferEnd}`);
					}
				}
				else {
					logger.log(`Main loading ${frag.sn} of [${levelDetails.startSN} ,${levelDetails.endSN}],level ${level}, pos:${pos},bufferEnd:${bufferEnd}`);
				}
			}
			catch(err) {
				logger.warn('error occurred while logging start of frag load');
			}

			if (frag.dateRange !== undefined) {
				hls.trigger(Event.FRAG_DATERANGE_UPDATE, { dateRange: frag.dateRange, startTime: frag.start });
			}

			//Mactrix changes end
			// ensure that we are not reloading the same fragments in loop ...
			if (this._fragLoadIdx !== undefined) {
				this._fragLoadIdx++;
			}
			else {
				this._fragLoadIdx = 0;
			}
			if (frag.loadCounter) {
				frag.loadCounter++;
				let maxThreshold = config.fragLoadingLoopThreshold;
				// if this frag has already been loaded 3 times, and if it has been reloaded recently
				if (frag.loadCounter > maxThreshold && (Math.abs(this._fragLoadIdx - frag.loadIdx) < maxThreshold)) {
					hls.trigger(Event.ERROR, { type: ErrorTypes.MEDIA_ERROR, details: ErrorDetails.FRAG_LOOP_LOADING_ERROR, fatal: false, frag: frag });
					return false;
				}
			}
			else {
				frag.loadCounter = 1;
			}
			frag.loadIdx = this._fragLoadIdx;
			this._fragCurrent = frag;
			this._startFragRequested = true;
			if (!isNaN(frag.sn)) {
				this._nextLoadPosition = frag.start + frag.duration;
			}
			frag.autoLevel = hls.autoLevelEnabled;
			frag.bitrateTest = this._bitrateTest;
			hls.trigger(Event.FRAG_LOADING, { frag: frag });
			// lazy demuxer init, as this could take some time ... do it during frag loading
			if (!this._demuxer) {
				this._demuxer = new Demuxer(hls, 'main');
			}
			this.state = State.FRAG_LOADING;
			return true;
		} //Mactrix remove line: performing key load if required and frag load in the one call

		return true; //Mactrix line added: need a general return value - getting here isn't indicative of an error so return true
	}

	set state(nextState) {
		if (this._state !== nextState) {
			const previousState = this._state;
			this._state = nextState;
			logger.log(`main stream state:${previousState}->${nextState}`);
			this.hls.trigger(Event.STREAM_STATE_TRANSITION, { previousState, nextState });
		}
	}

	get state() {
		return this._state;
	}

	getBufferedFrag(position) {
		return BinarySearch.search(this._bufferedFrags, function (frag) {
			if (position < frag.startPTS) {
				return -1;
			}
			else if (position > frag.endPTS) {
				return 1;
			}
			return 0;
		});
	}

	get currentLevel() {
		let media = this.media;
		if (media) {
			const frag = this.getBufferedFrag(media.currentTime);
			if (frag) {
				return frag.level;
			}
		}
		return -1;
	}

	get nextBufferedFrag() {
		let media = this.media;
		if (media) {
			// first get end range of current fragment
			return this.followingBufferedFrag(this.getBufferedFrag(media.currentTime));
		}
		else {
			return null;
		}
	}

	followingBufferedFrag(frag) {
		if (frag) {
			// try to get range of next fragment (500ms after this range)
			return this.getBufferedFrag(frag.endPTS + 0.5);
		}
		return null;
	}

	get nextLevel() {
		const frag = this.nextBufferedFrag;
		if (frag) {
			return frag.level;
		}
		else {
			return -1;
		}
	}

  /*
	on immediate level switch :
	 - pause playback if playing
	 - cancel any pending load request
	 - and trigger a buffer flush
  */
	immediateLevelSwitch() {
		logger.log('immediateLevelSwitch');
		if (!this._immediateSwitch) {
			this._immediateSwitch = true;
			let media = this.media;
			let previouslyPaused;

			if (media) {
				previouslyPaused = media.paused;
				media.pause();
			}
			else {
		// don't restart playback after instant level switch in case media not attached
				previouslyPaused = true;
			}
			this._previouslyPaused = previouslyPaused;
		}
		var fragCurrent = this._fragCurrent;
		if (fragCurrent && fragCurrent.loader) {
			fragCurrent.loader.abort();
		}
		this._fragCurrent = null;
	// increase fragment load Index to avoid frag loop loading error after buffer flush
		this._fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
	// flush everything
		this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
	}

  /*
	 on immediate level switch end, after new fragment has been buffered :
	  - nudge video decoder by slightly adjusting video currentTime (if currentTime buffered)
	  - resume the playback if needed
  */
	immediateLevelSwitchEnd() {
		let media = this.media;
		if (media && media.buffered.length) {
			this._immediateSwitch = false;
			if(BufferHelper.isBuffered(media, media.currentTime)) {
		// only nudge if currentTime is buffered
				media.currentTime -= 0.0001;
			}
			if (!this._previouslyPaused) {
				media.play();
			}
		}
	}

	nextLevelSwitch() {
	/* try to switch ASAP without breaking video playback :
	   in order to ensure smooth but quick level switching,
	  we need to find the next flushable buffer range
	  we should take into account new segment fetch time
	*/
		let media = this.media;
	// ensure that media is defined and that metadata are available (to retrieve currentTime)
		if (media && media.readyState) {
			let fetchdelay;
			let fragPlayingCurrent;
			let nextBufferedFrag;
			// increase fragment load Index to avoid frag loop loading error after buffer flush
			this._fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
			fragPlayingCurrent = this.getBufferedFrag(media.currentTime);
			if (fragPlayingCurrent && fragPlayingCurrent.startPTS > 1) {
				// flush buffer preceding current fragment (flush until current fragment start offset)
				// minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
				this.flushMainBuffer(0, fragPlayingCurrent.startPTS - 1);
			}
			if (!media.paused) {
				// add a safety delay of 1s
				var nextLevelId = this.hls.nextLoadLevel;
				var nextLevel = this._levels[nextLevelId];
				var fragLastKbps = this._fragLastKbps;

				if (fragLastKbps && this._fragCurrent) {
					fetchdelay = this._fragCurrent.duration * nextLevel.bitrate / (1000 * fragLastKbps) + 1;
				}
				else {
					fetchdelay = 0;
				}
			}
			else {
				fetchdelay = 0;
			}

			//logger.log('fetchdelay:'+fetchdelay);
			// find buffer range that will be reached once new fragment will be fetched
			nextBufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
			if (nextBufferedFrag) {
				// we can flush buffer range following this one without stalling playback
				nextBufferedFrag = this.followingBufferedFrag(nextBufferedFrag);
				if (nextBufferedFrag) {
					// if we are here, we can also cancel any loading/demuxing in progress, as they are useless
					var fragCurrent = this._fragCurrent;
					if (fragCurrent && fragCurrent.loader) {
						fragCurrent.loader.abort();
					}
					this._fragCurrent = null;
					// flush position is the start position of this new buffer
					this.flushMainBuffer(nextBufferedFrag.startPTS, Number.POSITIVE_INFINITY);
				}
			}
		}
	}

	flushMainBuffer(startOffset, endOffset) {
		this.state = State.BUFFER_FLUSHING;
		let flushScope = { startOffset: startOffset, endOffset: endOffset };
		// if alternate audio tracks are used, only flush video, otherwise flush everything
		if (this._altAudio) {
			flushScope.type = 'video';
		}
		this.hls.trigger(Event.BUFFER_FLUSHING, flushScope);
	}

	onMediaAttached(data) {
		var media = this.media = this.mediaBuffer = data.media;
		this.videoBuffer = null;
		this.onvseeking = this.onMediaSeeking.bind(this);
		this.onvseeked = this.onMediaSeeked.bind(this);
		this.onvended = this.onMediaEnded.bind(this);
		this.onvcanplaythrough = this.onMediaCanPlayThrough.bind(this);
		media.addEventListener('seeking', this.onvseeking);
		media.addEventListener('seeked', this.onvseeked);
		media.addEventListener('ended', this.onvended);
		media.addEventListener('canplaythrough', this.onvcanplaythrough);
		let config = this.config;
		if(this._levels && config.autoStartLoad) {
			this.hls.startLoad(config.startPosition);
		}
	}

	onMediaDetaching() {
		var media = this.media;
		if (media && media.ended) {
			logger.log('MSE detaching and video ended, reset startPosition');
			this._startPosition = this._lastCurrentTime = 0;
		}

		// reset fragment loading counter on MSE detaching to avoid reporting FRAG_LOOP_LOADING_ERROR after error recovery
		var levels = this._levels;
		if (levels) {
			// reset fragment load counter
			levels.forEach(level => {
				if(level.details) {
					level.details.fragments.forEach(fragment => {
						fragment.loadCounter = undefined;
						fragment.backtracked = undefined;
					});
				}
			});
		}
		// remove video listeners
		if (media) {
			media.removeEventListener('seeking', this.onvseeking);
			media.removeEventListener('seeked', this.onvseeked);
			media.removeEventListener('ended', this.onvended);
			this.onvseeking = this.onvseeked = this.onvended = null;
		}
		this.media = this.mediaBuffer = this.videoBuffer = null;
		this._loadedMetadata = false;
//Mactrix changes begin
		this.initialPdt = undefined;
//Mactrix changes end
		this.stopLoad();
	}

	onMediaSeeking() {
		const media = this.media;
		let currentTime = media ? media.currentTime : undefined;
		const config = this.config;
		logger.log(`media seeking to: ${currentTime.toFixed(3)}`);

		this.seekOverNearbyAudioGap(false);

		if (this.state === State.FRAG_LOADING) {
			let mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media;
			let bufferInfo = BufferHelper.bufferInfo(mediaBuffer, currentTime, this.config.maxBufferHole);
			let fragCurrent = this._fragCurrent;
		// check if we are seeking to a unbuffered area AND if frag loading is in progress
			if (bufferInfo.len === 0 && fragCurrent) {
				let tolerance = config.maxFragLookUpTolerance;
				let fragStartOffset = fragCurrent.start - tolerance;
				let fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;

		// check if we seek position will be out of currently loaded frag range : if out cancel frag load, if in, don't do anything
				if (currentTime < fragStartOffset || currentTime > fragEndOffset) {
					if (fragCurrent.loader) {
						logger.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
						fragCurrent.loader.abort();
					}
					this._fragCurrent = null;
					this._fragPrevious = null;
					// switch to IDLE state to load new fragment
					this.state = State.IDLE;
				}
				else {
					logger.log('seeking outside of buffer but within currently loaded fragment range');
				}
			}
		}
		else if (this.state === State.ENDED) {
			//clear fragPrevious, to prevent an immediate switch back to ENDED if loading fails
			this._fragPrevious = null;
		// switch to IDLE state to check for potential new fragment
			this.state = State.IDLE;
//Mactrix changes begin: not having this causes the buffered range tests to fail
//disabled as this is no longer needed and is causing issues with startup in IE/Edge
/*
	} else if (this._state === State.WAITING_LEVEL) {
		this._fragPrevious = null;*/
		}
//Mactrix changes end
		if (media) {
			this._lastCurrentTime = currentTime;

			if(this._playbackStarted && this.state !== State.PARSING) {
				this._fragPrevious = null;
				this.state = State.IDLE;
			}
		}
	// avoid reporting fragment loop loading error in case user is seeking several times on same position
		if (this.state !== State.FRAG_LOADING && this._fragLoadIdx !== undefined) {
			this._fragLoadIdx += 2 * config.fragLoadingLoopThreshold;
		}
	// in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
		if(!this._loadedMetadata) {
			this._nextLoadPosition = this._startPosition = currentTime;
		}
		this.hls.trigger(Event.BUFFER_SOURCE_SEEKING); //Mactrix addition
	// tick to speed up processing
		this.tick();
	}


	onAudioTrackUpdated() {
		this.seekOverNearbyAudioGap(false);
	}


	isThereAnAudioGap(time, increaseRange) {
		let gapEnd = undefined;

		if(!this._audioGapSeeking && this._altAudio) {
			let audioController = this.hls.audioStreamController;
			let track = audioController.tracks[audioController.trackId];

			if(track) {
				if(track.gapList.length > 0) {
					let offset = increaseRange ? track.details.averagetargetduration : 0;
					for(let i = 0; i < track.gapList.length; i++) {
						if(!this._audioGapSeeking && time < track.gapList[i].end && time > track.gapList[i].start - offset) {
							gapEnd = track.gapList[i].end;
						}
					}
				}
			}
		}

		return gapEnd;
	}


	seekOverNearbyAudioGap(increaseRange) {
		if(this.media) {
			let currTime = this.media.currentTime;
			let gapEndToSeekTo = this.isThereAnAudioGap(currTime, increaseRange);

			if(!this._audioGapSeeking && gapEndToSeekTo !== undefined) {
				let nudgeTime = gapEndToSeekTo + 0.001;
				//nudge a bit further than end of gap, as Chrome's lack of rounding on seeks may cause us to fall into the gap again

				logger.warn(`adjusting currentTime from ${currTime} to ${nudgeTime} due to audio gap`);
				if (this.hls._preBufferSeeks === false) {
					this.media.currentTime = nudgeTime;
				}
				else {
					this.hls.bufferBeforeSeeking = nudgeTime;
				}
				this._audioGapSeeking = true;
			}
		}
	}


	onMediaSeeked() {
		logger.log(`media seeked to ${this.media.currentTime.toFixed(3)}`);

		if(this.hls.browTizen3) {
			this._clearFragPrevious = true;
		}
/* Mactrix replace start
	// tick to speed up FRAGMENT_PLAYING triggering
	this.tick();
Mactrix replace end */
//Mactrix replacement start
		if (!this.hls._inSlowDetach) {
			this.tick();
		}
		else {
			logger.log('slow detach seek finished');

			if (this.hls.streamCoordinator.checkReadyForDispose(true, undefined)) {
				this.hls._doCompleteSlowDetach();
			}
		}

		this._audioGapSeeking = false;
//Mactrix replacement end
	}

	onMediaEnded() {
		logger.log('media ended');
	// reset startPosition and lastCurrentTime to restart playback @ stream beginning
		this._startPosition = this._lastCurrentTime = 0;
	}

	onMediaCanPlayThrough() {
		this._playbackStarted = true;
	}

	onManifestLoading() {
	// reset buffer on manifest loading
		logger.log('trigger BUFFER_RESET');
		this.hls.trigger(Event.BUFFER_RESET);
		this._bufferedFrags = [];
		this._stalled = false;
		this._startPosition = this._lastCurrentTime = 0;
		this._altAudio = false; //Mactrix line added, reset usage of audio stream controller
		this._fragBufferCount = 0;
		this.cmaf = false;
	}

	onManifestParsed(data) {
		let aac = false;
		let heaac = false;
		let codec;

		data.levels.forEach(level => {
			// detect if we have different kind of audio codecs used amongst playlists
			codec = level.audioCodec;
			if (codec) {
				if (codec.indexOf('mp4a.40.2') !== -1) {
					aac = true;
				}
				if (codec.indexOf('mp4a.40.5') !== -1) {
					heaac = true;
				}
			}

			level.deadFragList = [];
			level.containsGaps = false;
		});
		this._audioCodecSwitch = (aac && heaac);
		if (this._audioCodecSwitch) {
			logger.log('both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
		}
		this._levels = data.levels;
		this._startFragRequested = false;

		const config = this.config;
		if (config.autoStartLoad) {
			this.hls.startLoad(config.startPosition);
		}
	}

	adjustStartBySlidingOffset(curDetails, newDetails) {
		let delta = newDetails.startSN - curDetails.startSN;
		let curFrags = curDetails.fragments;

		if (delta >= 0 && delta < curFrags.length) {
		// adjust start by sliding offset
			const sliding = curFrags[delta].start;
			let newFrags = newDetails.fragments;
			const newFragsCount = newFrags.length;
			for(let i = 0; i < newFragsCount; i++) {
				newFrags[i].start += sliding;
			}
		}
	}

	adjustStartByBasePdt(newDetails, pdt) {
		let date;
		//logger.log(`adjustStartByBasePdt offset pdt : ${pdt}`);
		let newFrags = newDetails.fragments;
		const newFragsCount = newFrags.length;
		for(let i = 0; i < newFragsCount; i++) {
			let frag = newFrags[i];
			if(frag.rawProgramDateTime) {
				date = new Date(new Date(frag.rawProgramDateTime).valueOf() - (frag.start * 1000));
				logger.log(`raw PDT: ${date}`);
				break;
			}
		}

		if(date !== undefined) {
			const offset = date.getTime() - pdt.getTime();
			const offsetBasePdt = newFrags[0].pdt - offset;

			for(let i = 0; i < newFragsCount; i++) {
				let frag = newFrags[i];
				frag.start = (frag.pdt - offsetBasePdt) / 1000;
			}
		}
	}

	onLevelLoaded(data) {
		let newDetails = data.details;
		let newLevelId = data.level;
		let curLevel = this._levels[newLevelId];
		let duration = newDetails.totalduration;
		let sliding = 0;

/* mactrix replace
	logger.log(`level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}],duration:${duration}`);
*/
		logger.log(`X level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}],duration:${duration} live:${newDetails.live}`); //Mactrix line changed, live added
		this._levelLastLoaded = newLevelId;

//Mactrix changes begin: store the base pdt ... this would cause problems if pdts were to appear mid stream .. shouldn't happen
		if(this.initialPdt === undefined && newDetails.fragments[0].pdt) {
			this.initialPdt = newDetails.fragments[0].pdt;
		}
//Mactrix changes end

		if (newDetails.live) {
			let curDetails = curLevel.details;
			if (curDetails && newDetails.fragments.length > 0) {
		// we already have details for that level, merge them
//Mactrix changes begin
				if(this.hls.streamCoordinator.basePdt) {
					this.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
				}
				else {
					//This case shouldn't hit, but it will on startup. Often it's not an issue as it'll just do a no-offset
					//as needed, but in a sliding live recovery it's bad. Since we're creating PDTs always now this whole
					//case probably can be deleted and just make the no-PDT case do no adjustment, but more testing is required. - SIEG
					logger.log('onLevelLoaded adjustStartBySlidingOffset NO BASEPDT YET');
					this.adjustStartBySlidingOffset(curDetails, newDetails);
				}
//Mactrix changes end
				sliding = newDetails.fragments[0].start;
				this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
				if (newDetails.PTSKnown) {  //this is now never true. Probably should remove PTSKnown and rework - SIEG
					logger.log(`live X playlist sliding :${sliding.toFixed(3)}`);
				}
				else {
					logger.log('live X playlist - outdated PTS, unknown sliding');
				}
			}
			else {
				//Mactrix additions start
				//if we know the base PDT we can sync and determine sliding
				if(this.hls.streamCoordinator.basePdt) {
					logger.log('live X playlist - first load, calculating slide by syncing to base PDT');
					this.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
					sliding = newDetails.fragments[0].start;
					logger.log(`basePDT live X playlist sliding:${sliding.toFixed(3)}`);
				}
				else {
				//Mactrix additions end
					newDetails.PTSKnown = false;
					logger.log('live X playlist - first load, unknown sliding');
				} //Mactrix line added
			}
		}
		else {
		//Mactrix additions start
		//resync VODs, if needed
			if(this.hls.streamCoordinator.basePdt) {
				this.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
			}
		//Mactrix additions end
			newDetails.PTSKnown = false;
		}

		newDetails.fragments.forEach((frag, index) => {
			if(frag.tagList.includes('GAP')) {
				this.removeDeadFrag(index, newDetails.fragments);
				curLevel.containsGaps = true;

				//check the frag that we just moved into this index
				while(newDetails.fragments[index] && newDetails.fragments[index].tagList.includes('GAP')) {
					this.removeDeadFrag(index, newDetails.fragments);
				}
			}
		});

		curLevel.deadFragList.forEach((deadSn) => {
			let index = newDetails.fragments.findIndex((element) => {
				return element.sn === deadSn;
			});

			if(index !== -1) {
				this.removeDeadFrag(index, newDetails.fragments);
			}
		});

		//reconfirm first and last SN, in case there are dead frags at start or end
		newDetails.startSN = newDetails.fragments[0].sn;
		newDetails.originalEndSN = newDetails.endSN;
		newDetails.endSN = newDetails.fragments[newDetails.fragments.length - 1].sn;

	// override level info
		curLevel.details = newDetails;
/* mactrix replace
	this.hls.trigger(Event.LEVEL_UPDATED, { details: newDetails, level: newLevelId });
*/
	//Mactrix change start
	// sje: beneficial to have sliding outside.
		this.hls.trigger(Event.LEVEL_UPDATED, { details: newDetails, level: newLevelId, sliding: sliding }); // mactrix: added sliding
	//Mactrix change end

		if (this._startFragRequested === false) {
	// compute start position if set to -1. use it straight away if value is defined
			if (this._startPosition === -1 || this._lastCurrentTime === -1) {
		// first, check if start time offset has been set in playlist, if yes, use this value
				let startTimeOffset = newDetails.startTimeOffset;
				if(!isNaN(startTimeOffset)) {
					if (startTimeOffset < 0) {
						logger.log(`negative start time offset ${startTimeOffset}, count from end of last fragment`);
						startTimeOffset = sliding + duration + startTimeOffset;
					}
					logger.log(`start time offset found in playlist, adjust startPosition to ${startTimeOffset}`);
					this._startPosition = startTimeOffset;
				}
				else {
					// if live playlist, set start position to be fragment N-this.config.liveSyncDurationCount (usually 3)
					if (newDetails.live) {
						this._startPosition = this.computeLivePosition(sliding, newDetails);
						logger.log(`configure startPosition to ${this._startPosition}`);
					}
					else {
						this._startPosition = 0;
					}
				}
				this._lastCurrentTime = this._startPosition;
			}
			this._nextLoadPosition = this._startPosition;
		}
	// only switch batck to IDLE state if we were waiting for level to start downloading a new fragment
		if (this.state === State.WAITING_LEVEL) {
			this.state = State.IDLE;
		}
	//trigger handler right now
/*Mactrix remove: when dealing with renditions we need to wait for the audio track to load so we can deal with pdt sync ... hopefully this won't
				  //stall the pipeline
	this.tick();
*/
	}

	onKeyLoaded() {
		if (this.state === State.KEY_LOADING) {
			this.state = State.IDLE;
			this.tick();
		}
	}

	isCMAF(buffer) {
		let initSegment = new DataView(buffer);
		let ftyp = 0x66747970;
		let cmaf = false;

		if (initSegment.getUint32(4) === ftyp) {
			cmaf = true;
		}

		//if we find the ftyp atom we assume cmaf otherwise ts
		//if ((initSegment[4] === 'f'.charCodeAt(0)) &&
		//	(initSegment[5] === 't'.charCodeAt(0)) &&
		//	(initSegment[6] === 'y'.charCodeAt(0)) &&
		//	(initSegment[7] === 'p'.charCodeAt(0))) {
		//	cmaf = true;
		//}

		return cmaf;
	}

	//this function is quickly hacked and needs to be revised in a number of ways .... TODO
	insertPssh(initSegment, initFrag) {
		let i;
		let newInitSegment = null;
		let base64str = null;
		let format = null;
		let levelkey = null;

		//
		if (this.hls.browChrome || this.hls.browFirefox) {
			format = 'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed';
		}
		else if (this.hls.browIE || this.hls.browEdge || this.hls.browTizen2 || this.hls.browTizen3) {
			format = 'com.microsoft.playready';
		}
/*
		else if (this.hls.browSafari) {
			if (initFrag.levelkeys[i].format === 'com.apple.streamingkeydelivery') {
				levelkey = initFrag.levelkeys[i];
				//get everything after the skd://
				//need to add a check for the ; and add that as the sub string end paramter
				base64str = levelkey.reluri.substring(6);
				break;
			}
		}
*/
//if(levelkey.format === 'SAMPLE-AES' || levelkey.format === 'SAMPLE-AES-CTR')
//(['AES-128', 'SAMPLE-AES', 'ISO-23001-7', 'SAMPLE-AES-CTR', 'SAMPLE-AES-CENC'].indexOf(decryptmethod) >= 0)) {

		//a short cut method for extracting the base64 from the uri, it doesn't pay attention to any other uri parameters
		if( format !== null) {
			for(i = 0; i < initFrag.levelkeys.length && base64str === null; i++) {
				levelkey = initFrag.levelkeys[i];

				if(levelkey.format === format) {
					let base64IndexStart = levelkey.reluri.indexOf('base64,');

					if(base64IndexStart >= 0) {
						let str = levelkey.reluri.substring(base64IndexStart);
						let base64IndexEnd = str.indexOf(';');

						if (base64IndexEnd < 0) {
							base64IndexEnd = str.length;
						}

						base64str = str.substring(7, base64IndexEnd);
					}
					else {
						//we didn't find 'base64,', emit an error as we can't decrypt this

						//maybe as a last resort we can search the init segment for the pssh, if we don't find it then emit an error as we can't decrypt this
					}
				}
			}
		}

		if(base64str) {
			let decodedStr = atob(base64str);
			let pssh = null;
			let count;
			let offset = 0;
			let fourcc = 0;
			let buffer;
			let dv;
			let moov = 0x6D6F6F76;

			if (format === 'com.microsoft.playready') {
			/*
				if we are PlayReady then the decodedStr just contains the PlayReady Object (PRO), we need to build the pssh and append the PRO
			*/
				let psshArray = new ArrayBuffer(decodedStr.length + 32); //32 - version zero pssh length
				dv = new DataView(psshArray);

				//pssh length
				dv.setUint32(0, psshArray.byteLength);
				dv.setUint32(4, 0x70737368); //'pssh'
				dv.setUint32(8, 0x00000000); //version
				dv.setUint32(12, 0x9A04F079); //drm guid
				dv.setUint32(16, 0x98404286);
				dv.setUint32(20, 0xAB92E65B);
				dv.setUint32(24, 0xE0885F95);
				dv.setUint32(28, decodedStr.length); //custom data length

				//insert the decoded string as the custom data at the end of the pssh
				offset = 32;

				pssh = new Uint8Array(psshArray);
			}
			else {
				//the decodedStr is the pssh
				pssh = new Uint8Array(decodedStr.length);
			}


			for (count = 0; count < decodedStr.length; count++) {
				pssh[count + offset] = decodedStr.charCodeAt(count);
			}

			//1. append the pssh to the end of the newInitSegment
			//newInitSegment = new Uint8Array(initSegment.byteLength + pssh.length);
			newInitSegment = new ArrayBuffer(initSegment.byteLength + pssh.length);
			dv = new DataView(newInitSegment);
			buffer = new Uint8Array(newInitSegment);
			buffer.set(new Uint8Array(initSegment), 0);
			buffer.set(pssh, initSegment.byteLength);

			//reset the offset for moov length changes
			offset = 0;

			//2. modify the moov length - search for the moov atom and increase its size by the pssh length
			do {
				let len = dv.getUint32(offset);
				fourcc = dv.getUint32(offset + 4);

				if(fourcc === moov) {
					dv.setUint32(offset, len + pssh.length);
				}
				else {
					offset += len;
				}

			} while(fourcc !== moov && offset < buffer.length);

			if(offset >= buffer.length - 8) {
				//bad init segment - emit error
			}
		}
		else if(levelkey && (levelkey.method === 'SAMPLE-AES' || levelkey.method === 'SAMPLE-AES-CTR' || levelkey.method === 'SAMPLE-AES-CENC')) {
			//clear key

			//we need a version one pssh with all the kids, no custom data

			//need to search for tenc to extact the kids

			let psshArray = new ArrayBuffer(52); //52 - version one pssh length with one kid
			let dv = new DataView(psshArray);
			let buffer;
			let offset = 0;
			let fourcc;
			let moov = 0x6D6F6F76;

			//pssh length
			dv.setUint32(0, psshArray.byteLength);
			dv.setUint32(4, 0x70737368); //'pssh'
			dv.setUint32(8, 0x01000000); //version
			dv.setUint32(12, 0x1077EFEC); //drm guid
			dv.setUint32(16, 0xC0B24D02);
			dv.setUint32(20, 0xACE33C1E);
			dv.setUint32(24, 0x52E2FB4B);
			dv.setUint32(28, 0x00000001); //number of kids
			dv.setUint32(32, 0x30303030);
			dv.setUint32(34, 0x30303030);
			dv.setUint32(40, 0x30303030);
			dv.setUint32(44, 0x30303030);
			dv.setUint32(48, 0x00000000); //custom data length

			newInitSegment = new ArrayBuffer(initSegment.byteLength + psshArray.byteLength);

			dv = new DataView(newInitSegment);
			buffer = new Uint8Array(newInitSegment);
			buffer.set(new Uint8Array(initSegment), 0);
			buffer.set(new Uint8Array(psshArray), initSegment.byteLength);

			//2. modify the moov length - search for the moov atom and increase its size by the pssh length
			do {
				let len = dv.getUint32(offset);
				fourcc = dv.getUint32(offset + 4);

				if(fourcc === moov) {
					dv.setUint32(offset, len + psshArray.byteLength);
				}
				else {
					offset += len;
				}

			} while(fourcc !== moov && offset < buffer.length);

			if(offset >= buffer.length - 8) {
				//bad init segment - emit error
			}
		}
		else {
			newInitSegment = initSegment;
		}

		return newInitSegment;
	}

	//this should be moved to the demuxer along with all other CMAF related functions
	getTimeScale(data) {
		let frag = muxjs.mp4.tools.inspect(new Uint8Array(data));
		let timeScale;
		let i;
		let j;
		let k;
		let l;

		for (i = 0; i < frag.length && timeScale === undefined; i++) {
			if (frag[i].type === 'moov') {
				for (j = 0; j < frag[i].boxes.length && timeScale === undefined; j++) {
					if (frag[i].boxes[j].type === 'mvhd') {
						timeScale = frag[i].boxes[j].timescale;
					}
					else if (frag[i].boxes[j].type === 'trak') {
						for (k = 0; k < frag[i].boxes[j].boxes.length && timeScale === undefined; k++) {
							if (frag[i].boxes[j].boxes[k].type === 'mdia') {
								for (l = 0; l < frag[i].boxes[j].boxes[k].boxes.length && timeScale === undefined; l++) {
									if (frag[i].boxes[j].boxes[k].boxes[l].type === 'mdhd') {
										timeScale = frag[i].boxes[j].boxes[k].boxes[l].timescale;
									}
								}
							}
						}
					}
				}
			}
		}

		if(timeScale === undefined) {
			logger.warn(`getTimeScale: No valid getTimeScale found, using the default getTimeScale of 30000`);
			timeScale = 30000;
		}

		return timeScale;
	}

	//this should be moved to the demuxer along with all other CMAF related functions
	getTimestampOffset(data, timeScale) {
		let frag = muxjs.mp4.tools.inspect(new Uint8Array(data));
		let ts = timeScale;
		let timestampOffset;
		let i;
		let j;
		let k;

		if(ts <= 0) {
			logger.warn(`getTimestampOffset: Invalid timeScale found, using the default value of 30000`);
			ts = 30000;
		}

		for (i = 0; i < frag.length && timestampOffset === undefined; i++) {
			if(frag[i].type === 'moof') {
				for(j = 0; j < frag[i].boxes.length && timestampOffset === undefined; j++) {
					if(frag[i].boxes[j].type === 'traf') {
						for(k = 0; k < frag[i].boxes[j].boxes.length && timestampOffset === undefined; k++) {
							if(frag[i].boxes[j].boxes[k].type === 'tfdt') {
								timestampOffset = frag[i].boxes[j].boxes[k].baseMediaDecodeTime / ts;
							}
						}
					}
				}
			}
		}

		if(timestampOffset === undefined) {
			logger.warn(`getTimestampOffset: No valid timestampOffset found, using the default timestampOffset of 0`);
			timestampOffset = 0;
		}

		return -timestampOffset;
	}

	onFragLoaded(data) {
		let fragCurrent = this._fragCurrent;
		let fragLoaded = data.frag;

		if (this.state === State.FRAG_LOADING &&
		fragCurrent &&
		fragLoaded.type === 'main' &&
		fragLoaded.level === fragCurrent.level &&
		fragLoaded.sn === fragCurrent.sn) {
			let stats = data.stats;
			let currentLevel = this._levels[fragCurrent.level];
			let details = currentLevel.details;

			this._flushOnStoppedBuffering = [];

			logger.log(`onFragLoaded: Loaded main ${fragCurrent.sn} of [${details.startSN} ,${details.endSN}], level ${fragCurrent.level}, size ${stats.loaded} bytes, load time ${stats.tload - stats.tfirst}ms, latency ${stats.tfirst - stats.trequest}ms`);
			// reset frag bitrate test in any case after frag loaded event
			this._bitrateTest = false;
			this._stats = stats;
			// if this frag was loaded to perform a bitrate test AND if hls.nextLoadLevel is greater than 0
			// then this means that we should be able to load a fragment at a higher quality level
			if (fragLoaded.bitrateTest === true && this.hls.nextLoadLevel) {
				// switch back to IDLE state ... we just loaded a fragment to determine adequate start bitrate and initialize autoswitch algo
				this.state = State.IDLE;
				this._startFragRequested = false;
				stats.tparsed = stats.tbuffered = performance.now();
				this.hls.trigger(Event.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id : 'main' });
				this.tick();
			}
			else if (this._waitForFlush) {
				logger.log('main aborting parse due to flush');
				this._checkIfBufferReady();
			}
			else if (fragLoaded.sn === 'initSegment') {
				this.state = State.IDLE;
				stats.tparsed = stats.tbuffered = performance.now();
				//details.initSegment.data = data.payload;
				details.initSegment.data = this.insertPssh(data.payload, details.initSegment);
				//details.isCMAF = this.isCMAF(details.initSegment.data);
				this.cmaf = this.isCMAF(details.initSegment.data);
				this.hls.trigger(Event.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id : 'main' });
				this.tick();
			}
			else {
				this.state = State.PARSING;
				// transmux the MPEG-TS data to ISO-BMFF segments
				let duration = details.totalduration;
				let level = fragCurrent.level;
				let sn = fragCurrent.sn;
				let audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;

				if(this._audioCodecSwap) {
					logger.log('swapping playlist audio codec');
					if(audioCodec === undefined) {
						audioCodec = this.lastAudioCodec;
					}
					if(audioCodec) {
						if(audioCodec.indexOf('mp4a.40.5') !== -1) {
							audioCodec = 'mp4a.40.2';
						}
						else {
							audioCodec = 'mp4a.40.5';
						}
					}
				}
				this._pendingBuffering = true;
				this._appended = false;
				logger.log(`Parsing ${sn} of [${details.startSN} ,${details.endSN}],level ${level}, cc ${fragCurrent.cc}`);
				// time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
				// and if media is not seeking (this is to overcome potential timestamp drifts between playlists and fragments)
				let media = this.media;
				let mediaSeeking = media && media.seeking;
				let accurateTimeOffset = !mediaSeeking && (details.PTSKnown || !details.live);
				let initSegmentData = details.initSegment ? details.initSegment.data : [];

				if(this.cmaf/*details.isCMAF*/) {
					if(details.initSegment.data) {
						let tracks = {};
						let initData = { tracks: tracks };
						initData.frag = fragLoaded;
						initData.id = 'main';

						//if audioCodec is present in the currentLevel but no videoCodec this would indicate audio only
						//need to test audio only
						if(currentLevel.videoCodec) {
							tracks.video = {
								container: 'video/mp4',
								codec: currentLevel.videoCodec,
								initSegment: details.initSegment.data,
								metadata: {
									width: currentLevel.width,
									height: currentLevel.height,
								},
								//temporary hack for fairplay - DO NOT rely on this as it will be removed!
								levelkeys: details.initSegment.levelkeys,
							};
						}
						else {
							tracks.audio = {
								container: 'audio/mp4',
								codec: currentLevel.audioCodec,
								initSegment: details.initSegment.data,
								metadata: {
									channelCount: 2, //get the correct value!
								},
								//temporary hack for fairplay - DO NOT rely on this as it will be removed!
								levelkeys: details.initSegment.levelkeys,
							};
						}

						if(!this.timestampOffset) {
							let timeScale = this.getTimeScale(details.initSegment.data);
							this.timestampOffset = this.getTimestampOffset(data.payload, timeScale);
						}

						this.onFragParsingInitSegment(initData);

						//only do this once per init segment
						//details.initSegment.data = null;
					}

					let payload = {
						data1: new Int8Array(data.payload),
						data2: null, //is ignored
						startPTS: fragCurrent.startDTS / 90e3,
						endPTS: fragCurrent.nextDTS / 90e3,
						startDTS: fragCurrent.startDTS / 90e3,
						endDTS: fragCurrent.nextDTS / 90e3,
						type: currentLevel.videoCodec ? 'video' : 'audio',
						nb: fragCurrent.frames,
						dropped: 0, //dropped
						duplicate: false, //would need to keep track of the last startDTS
						dts: fragCurrent.startDTS,
						frag: fragCurrent,
						id: 'main',
					};

					this.onFragParsingData(payload);
					this.onFragParsed(payload);
				}
				else {
					let demuxer = this._demuxer;
					if (!demuxer) {
						demuxer = this._demuxer = new Demuxer(this.hls, 'main');
					}

					let deliberateGap = false;
					//we need to keep the gap value for later, in case we end up seeking into the gap
					if(fragCurrent.unmodifiedGap && fragCurrent.unmodifiedGap !== fragCurrent.gap) {
						fragCurrent.gap = fragCurrent.unmodifiedGap;
					}
					else {
						fragCurrent.unmodifiedGap = fragCurrent.gap ? fragCurrent.gap : 0;
					}

					if(this._fragPrevious && fragCurrent.gap) {
						let fragPrevious = this._fragPrevious;
						let tolerance = this._levels[level].details.averagetargetduration / 2;
						//if the start of this frag (minus the gap) is close to the end of the previous one, tell muxjs that this is contiguous
						if(fragCurrent.start - (fragCurrent.gap / 1000) > fragPrevious.start + tolerance
						&& fragCurrent.start - (fragCurrent.gap / 1000) < fragPrevious.start + (tolerance * 3)) {
							deliberateGap = true;
						}

						//If there's no alt audio, we can just remove the gap entirely
						//Otherwise, if we're buffered inside the gap, we got the frag from another variant and don't need to fill it in
						if(!this._altAudio || BufferHelper.isBuffered(media, fragCurrent.start - (fragCurrent.gap / (1000 * 2)))) { //1000 to convert to seconds, 2 to get halfway into the gap
							fragCurrent.gap = 0;
						}
					}

					demuxer.push(data.payload, initSegmentData, audioCodec, currentLevel.videoCodec, fragCurrent, duration, accurateTimeOffset, this.fragAborted, deliberateGap);
					this.fragAborted = false;
					this._parsingDataCount = 0;
				}
			}
		}
		this._fragLoadError = 0;
		this._gapCycleBase = undefined;
	}

	onFragParsingInitSegment(data) {
		const hls = this.hls;
		const fragCurrent = this._fragCurrent;
		const fragNew = data.frag;
		if (fragCurrent &&
		data.id === 'main' &&
		fragNew.sn === fragCurrent.sn &&
		fragNew.level === fragCurrent.level &&
		this.state === State.PARSING) {
			let tracks = data.tracks;
			let trackName;
			let track;

			// if audio track is expected to come from audio stream controller, discard any coming from main
			if (tracks.audio && this._altAudio) {
				delete tracks.audio;
			}
			// include levelCodec in audio and video tracks
			track = tracks.audio;
			if(track) {
/* mactrix replace
				var audioCodec = this._levels[this._level].audioCodec,
				ua = navigator.userAgent.toLowerCase();
*/
				var audioCodec = this._levels[this._level].audioCodec; // mactrix change: new browser detection, remove ua, and trailing comma
				if(audioCodec && this._audioCodecSwap) {
					logger.log('swapping playlist audio codec');
					if(audioCodec.indexOf('mp4a.40.5') !== -1) {
						audioCodec = 'mp4a.40.2';
					}
					else {
						audioCodec = 'mp4a.40.5';
					}
				}
				// in case AAC and HE-AAC audio codecs are signalled in manifest
				// force HE-AAC , as it seems that most browsers prefers that way,
				// except for mono streams OR on FF
				// these conditions might need to be reviewed ...
				if (this._audioCodecSwitch) {
					// don't force HE-AAC if mono stream
					if(track.metadata.channelCount !== 1 &&
						// don't force HE-AAC if firefox
						hls.browFirefox === true
					) { // mactrix change: new browser detection
						audioCodec = 'mp4a.40.5';
					}
				}
		// HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
/* mactrix replace
		if(ua.indexOf('android') !== -1 && track.container !== 'audio/mpeg') { // Exclude mpeg audio
*/
				if( hls.browAndroid === true && track.container !== 'audio/mpeg') { // Exclude mpeg audio - mactrix change: new browser detection.
					audioCodec = 'mp4a.40.2';
					logger.log(`Android: force audio codec to ${audioCodec}`);
				}
				track.levelCodec = audioCodec;
				track.id = data.id;
			}
			track = tracks.video;
			if(track) {
				track.levelCodec = this._levels[this._level].videoCodec;
				track.id = data.id;
			}
			hls.trigger(Event.BUFFER_CODECS, tracks);
			// loop through tracks that are going to be provided to bufferController
			for (trackName in tracks) { //eslint-disable-line guard-for-in
				track = tracks[trackName];
				logger.log(`main track:${trackName},container:${track.container},codecs[level/parsed]=[${track.levelCodec}/${track.codec}]`);
				var initSegment = track.initSegment;
				if (initSegment) {
					this._appended = true;
					// arm pending Buffering flag before appending a segment
					this._pendingBuffering = true;

					hls.trigger(Event.BUFFER_APPENDING, {
						type: trackName,
						data: initSegment,
						parent : 'main',
						content : 'initSegment',
						sn: fragCurrent.sn,
					});
				}
			}
	//trigger handler right now
			this.tick();
		}
	}

	onFragParsingData(data) {
		const fragCurrent = this._fragCurrent;
		const fragNew = data.frag;
		if (fragCurrent &&
		data.id === 'main' &&
		fragNew.sn === fragCurrent.sn &&
		fragNew.level === fragCurrent.level &&
		!(data.type === 'audio' && this._altAudio) && // filter out main audio if audio track is loaded through audio stream controller
		this.state === State.PARSING) {
//Mactrix changes begin: don't do anything besides tick() if this is a duplicate
			if(!data.duplicate /*|| this._bufferNextDuplicate*/) {
				/*this._bufferNextDuplicate = false;*/
//Mactrix changes end
				let level = this._levels[this._level];
				//let frag = fragCurrent;

				if (isNaN(data.endPTS)) {
					data.endPTS = data.startPTS + fragCurrent.duration;
					data.endDTS = data.startDTS + fragCurrent.duration;
				}

				this._flushOnStoppedBuffering.push({ type: data.type, start: data.startPTS, end: data.endPTS });
				//Mactrix line addded, keep chunk time info so we can flush half-buffered frags if the buffering process is interrupted

				logger.log(`onFragParsingData Main Parsed ${data.type} ${data.frag.sn},PTS:[${data.startPTS.toFixed(3)},${data.endPTS.toFixed(3)}],DTS:[${data.startDTS.toFixed(3)}/${data.endDTS.toFixed(3)}],nb:${data.nb},dropped:${data.dropped || 0}`);

			// Detect gaps in a fragment  and try to fix it by finding a keyframe in the previous fragment (see _findFragments)
	/*Mactrix remove: muxjs keeps a gop cache and does key frame extending to handle this ... data.dropped should always be false
			  if(data.type === 'video') {
				frag.dropped = data.dropped;
				if (frag.dropped) {
				if (!frag.backtracked) {
					// Return back to the IDLE state without appending to buffer
					// Causes findFragments to backtrack a segment and find the keyframe
					// Audio fragments arriving before video sets the nextLoadPosition, causing _findFragments to skip the backtracked fragment
					frag.backtracked = true;
					this._nextLoadPosition = data.startPTS;
					this._state = State.IDLE;
					this.tick();
					return;
				} else {
					logger.warn('Already backtracked on this fragment, appending with the gap');
				}
				} else {
				// Only reset the backtracked flag if we've loaded the frag without any dropped frames
				frag.backtracked = false;
				}
			}
	*/
				const hls = this.hls;

				if (this._waitForFlush) {
					logger.log('main aborting append due to flush');
					this._checkIfBufferReady();

					this.fragAborted = true;
				}
				else {
					hls.trigger(Event.LEVEL_PTS_UPDATED, { details: level.details, level: this._level,
						drift: 0, type: data.type, start: data.startPTS, end: data.endPTS });

					// has remuxer dropped video frames located before first keyframe ?
					[data.data1, data.data2].forEach(buffer => {
						// only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
						// in that case it is useless to append following segments
						if (buffer && buffer.length && this.state === State.PARSING) {
							this._appended = true;
						// arm pending Buffering flag before appending a segment
							this._pendingBuffering = true;

							hls.trigger(Event.BUFFER_APPENDING, {
								type: data.type,
								data: buffer,
								parent : 'main',
								content : 'data',
								sn: data.frag.sn,
								level : data.frag.level,
								start: data.startPTS,
								end: data.endPTS,
								dts: data.dts,
								targetDuration: data.frag.duration,
							});
							this._parsingDataCount++;
						}
					});
				}

			}
		//trigger handler right now
			this.tick();
		}
	}

	onFragParsed(data) {
		const fragCurrent = this._fragCurrent;
		const fragNew = data.frag;
		if (fragCurrent &&
		data.id === 'main' &&
		fragNew.sn === fragCurrent.sn &&
		fragNew.level === fragCurrent.level &&
		this.state === State.PARSING &&
		this._parsingDataCount > 0) {
			this._stats.tparsed = performance.now();
			this.state = State.PARSED;
			this._parsingDataCount = 0;
			this._checkAppendedParsed();
		}
		else if (fragCurrent &&
		data.id === 'main' &&
		fragNew.sn === fragCurrent.sn &&
		fragNew.level === fragCurrent.level &&
		this.state === State.PARSING &&
		this._parsingDataCount === 0) {
			this.state = State.IDLE;
			this._fragCurrent = null;
			this._fragPrevious = null;
		}
	}

	onAudioTrackSwitching(data) {
	// if any URL found on new audio track, it is an alternate audio track
		this.forceStopFetching = true; //Mactrix line added, stop frag selector from operating in the middle of a track switch
		let altAudio = !!data.url;
		let trackId = data.id;

	//Mactrix additions start
	//clear load counter on track switch to prevent false fragLoopLoadingErrors
		let levels = this._levels;
		if (levels) {
			// reset fragment load counter
			levels.forEach(level => {
				if(level.details) {
					level.details.fragments.forEach(fragment => {
						fragment.loadCounter = undefined;
						fragment.backtracked = undefined;
					});
				}
			});
		}
	//Mactrix additions end

		// if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
		// don't do anything if we switch to alt audio: audio stream controller is handling it.
		// we will just have to change buffer scheduling on audioTrackSwitched
		if (!altAudio) {
			if (this.mediaBuffer !== this.media) {
				logger.log(`switching on main audio, use media.buffered to schedule main fragment loading`);
				this.mediaBuffer = this.media;
				let fragCurrent = this._fragCurrent;
				// we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
				if (fragCurrent.loader) {
					logger.log('switching to main audio track, cancel main fragment load');
					fragCurrent.loader.abort();
				}
				this._fragCurrent = null;
				this._fragPrevious = null;
				// destroy demuxer to force init segment generation (following audio switch)
				if (this._demuxer) {
					this._demuxer.destroy();
					this._demuxer = null;
				}
				// switch to IDLE state to load new fragment
				this.state = State.IDLE;
			}
			const hls = this.hls;
			// switching to main audio, flush all audio and trigger track switched
		/* Mactrix line removed, this has been moved to hls.js due to issue where audio buffer would not flush on change if audio buffer is full
			hls.trigger(Event.BUFFER_FLUSHING, {startOffset: 0 , endOffset: Number.POSITIVE_INFINITY, type : 'audio'});
		*/
			hls.trigger(Event.AUDIO_TRACK_SWITCHED, { id : trackId });
			this._altAudio = false;
		}
	//Mactrix additions start, prevent race condition when starting on latebound audio in Safari
		else {
			this._altAudio = true;
		}
	//Mactrix additions end
	}

	onAudioTrackSwitched(data) {
		const hls = this.hls;
	/*
	var trackId = data.id,
	altAudio = !!this.hls.audioTracks[trackId].url;
	*/
	//Mactrix changes begin
	//add audio rendition group support
		var trackId = data.id;
		var rendition = hls.audioTrackController.getRenditionNumber(trackId);
		var altAudio = !!hls.audioTracks[trackId].renditions[rendition].url;
	//Mactrix changes end
		if (altAudio) {
			let videoBuffer = this.videoBuffer;
			// if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
			if (videoBuffer && this.mediaBuffer !== videoBuffer) {
				logger.log(`switching on alternate audio, use video.buffered to schedule main fragment loading`);
				this.mediaBuffer = videoBuffer;
			}
		}
		this._altAudio = altAudio;
		this.forceStopFetching = false; //Mactrix line added, stop frag selector from operating in the middle of a track switch
		this.tick();
	}

	onBufferCreated(data) {
		let tracks = data.tracks;
		let mediaTrack;
		let name;
		let alternate = false;

		for(var type in tracks) {
			if (type === 'video' || type === 'audio') {
				let track = tracks[type];
				if (track.id === 'main') {
					name = type;
					mediaTrack = track;
			// keep video source buffer reference
					if (type === 'video') {
						this.videoBuffer = tracks[type].buffer;

						if (this.timestampOffset) {
							this.videoBuffer.timestampOffset = this.timestampOffset;
						}
					}
				}
				else {
					alternate = true;
				}
			}
		}
		if (alternate && mediaTrack) {
			logger.log(`alternate track found, use ${name}.buffered to schedule main fragment loading`);
			this.mediaBuffer = mediaTrack.buffer;

			if (this.timestampOffset) {
				this.mediaBuffer.timestampOffset = this.timestampOffset;
			}
		}
		else {
			this.mediaBuffer = this.media;
		}
	}

	onBufferAppended(data) {
		if (data.parent === 'main') {
			this._fragBufferCount++;
			const state = this.state;
			if (state === State.PARSING || state === State.PARSED) {
		// check if all buffers have been appended
				this._pendingBuffering = (data.pending > 0);
				this._checkAppendedParsed();
			}
		}
	}

	_checkAppendedParsed() {
	//trigger handler right now
		if (this.state === State.PARSED && (!this._appended || !this._pendingBuffering)) {
			const frag = this._fragCurrent;
			if (frag) {
				const media = this.mediaBuffer ? this.mediaBuffer : this.media;
				try {
					logger.log(`main buffered : ${TimeRanges.toString(media.buffered)} sn : ${frag.sn}`);
				}
				catch(err) {
					logger.log(`main buffered : {TimeRanges.toString(media.buffered)} failed. err ${err.message}`);
				}
		// filter fragments potentially evicted from buffer. this is to avoid memleak on live streams
				let bufferedFrags = this._bufferedFrags.filter( filterFrag => {
					return BufferHelper.isBuffered(media, (filterFrag.startPTS + filterFrag.endPTS) / 2);
				});
		// push new range
				bufferedFrags.push(frag);
		// sort frags, as we use BinarySearch for lookup in getBufferedFrag ...
				this._bufferedFrags = bufferedFrags.sort(function (a, b) {
					return (a.startPTS - b.startPTS);
				});
				this._fragPrevious = frag;
				const stats = this._stats;
				stats.tbuffered = performance.now();
		// we should get rid of this._fragLastKbps
				this._fragLastKbps = Math.round(8 * stats.total / (stats.tbuffered - stats.tfirst));
				this.hls.trigger(Event.FRAG_BUFFERED, { stats: stats, frag: frag, id : 'main' });
				if(this._bufferBeforeSeekingTime !== undefined && this._bufferBeforeSeekingApplied) {
					if (BufferHelper.isBuffered(this.media, this._bufferBeforeSeekingTime)) {
						let bufferedTime = this._bufferBeforeSeekingTime;

						this._bufferBeforeSeekingTime = undefined;
						this._bufferBeforeSeekingApplied = undefined;

						logger.log(`bufferBeforeSeeking: Ready.`);
						this.hls.trigger(Event.SEEK_READY, { time: bufferedTime });
					}
					else {
						let tryAgain = true;

						if (this.hls.streamCoordinator.checkIfRenditionsAreActive && this.hls.audioStreamController.bufferBeforeSeeking !== undefined ) {
							tryAgain = false;
						}
						if (tryAgain) {
							let targetTime = this._bufferBeforeSeekingTime + 1;

							logger.log(`bufferBeforeSeeking: Buffered main but desired time not found. Pushing forward target time to ${targetTime}.`);

							this.hls.bufferBeforeSeeking = targetTime;
						}
						else {
							logger.log(`bufferBeforeSeeking: Not ready.`);
						}
					}
				}
				if(frag.unmodifiedGap && !BufferHelper.isBuffered(media, this.media.currentTime)) {
					if(this.media.currentTime < frag.start && this.media.currentTime > frag.start - frag.unmodifiedGap) {
						logger.warn('seeked into a gap, seeking to start of frag');
						//Safari freezes when trying to seek to the exact end of the seekable range
						//The extra millisecond still causes a media element error but at least it recovers
						this.media.currentTime = frag.start + 0.001;
					}
				}
				this.state = State.IDLE;
			}
			this.tick();
		}
	}

	onError(data) {
		let frag = data.frag || this._fragCurrent;
		// don't handle frag error not related to main fragment
		if (frag && frag.type !== 'main') {
			return;
		}
		let media = this.media;
		// 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end

		let desiredPlayPoint = this._bufferBeforeSeekingTime;
		if(desiredPlayPoint === undefined && this.media) {
			desiredPlayPoint = this.media.currentTime;
		}

		let mediaBuffered = media && BufferHelper.isBuffered(media, desiredPlayPoint) && BufferHelper.isBuffered(media, desiredPlayPoint + 0.5);

		switch(data.details) {
		case ErrorDetails.FRAG_LOAD_ERROR:
		case ErrorDetails.FRAG_LOAD_TIMEOUT:
		case ErrorDetails.KEY_LOAD_ERROR:
		case ErrorDetails.KEY_LOAD_TIMEOUT:
			if(!data.fatal) {
				var loadError = this._fragLoadError;
				if(loadError) {
					loadError++;
				}
				else {
					loadError = 1;
				}
				let config = this.config;
				// keep retrying / don't raise fatal network error if current position is buffered or if in automode with current level not 0
				if (loadError < 2 || this._fragBufferCount !== 0) {
					this._fragLoadError = loadError;
				// reset load counter to avoid frag loop loading error
					frag.loadCounter = 0;
				// exponential backoff capped to config.fragLoadingMaxRetryTimeout
					let delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
					if(this._skipReloadDelay) {
						delay = 0;
						this._skipReloadDelay = false;
					}
					logger.warn(`mediaController: frag loading failed, retry in ${delay} ms`);
					this.retryDate = performance.now() + delay;
				// retry loading state
				// if loadedmetadata is not set, it means that we are emergency switch down on first frag
				// in that case, reset startFragRequested flag
					if(!this._loadedMetadata) {
						this._startFragRequested = false;
						this._nextLoadPosition = this._startPosition;
					}
					this.state = State.FRAG_LOADING_WAITING_RETRY;
				}
				else {
					logger.error(`mediaController: ${data.details} reaches max retry, redispatch as fatal ...`);
			// switch error to fatal
					data.fatal = true;
					this.state = State.ERROR;
				}
			}
			break;
		case ErrorDetails.FRAG_LOOP_LOADING_ERROR:
			if(!data.fatal) {
				// if buffer is not empty
				if (mediaBuffered) {
			// try to reduce max buffer length : rationale is that we could get
			// frag loop loading error because of buffer eviction
					this._reduceMaxBufferLength(frag.duration);
					this.state = State.IDLE;
			/* Mactrix lines removed, this isn't a good check for if a frag loop is fatal, as audio track changes may accidentally trigger it
		  } else {
			// buffer empty. report as fatal if in manual mode or if lowest level.
			// level controller takes care of emergency switch down logic
			if (!frag.autoLevel || frag.level === 0) {
			  // switch error to fatal
			  data.fatal = true;
			  this._state = State.ERROR;
			}
			*/
				}
			}
			break;
		case ErrorDetails.LEVEL_LOAD_ERROR:
		case ErrorDetails.LEVEL_LOAD_TIMEOUT:
			if(this.state !== State.ERROR) {
				if (data.fatal) {
					// if fatal error, stop processing
					this.state = State.ERROR;
					logger.warn(`streamController: ${data.details},switch to ${this.state} state ...`);
				}
				else {
			// in cas of non fatal error while waiting level load to be completed, switch back to IDLE
					if (this.state === State.WAITING_LEVEL) {
						this.state = State.IDLE;
					}
				}
			}
			break;
		case ErrorDetails.BUFFER_FULL_ERROR:
		// if in appending state
			if (data.parent === 'main' && (this.state === State.PARSING || this.state === State.PARSED)) {
				// reduce max buf len if current position is buffered
				if (mediaBuffered) {
					this._reduceMaxBufferLength(this.config.maxBufferLength);
			//Mactrix additions start
			//its possible for one buffer to succeed and the other to fail, which can cause problems with timestamp calculations in Edge
			//this flushes the half-buffered frag, which corrects the timestamps on the next load attempt
					this._flushOnStoppedBuffering.forEach((fragInfo) => {
						this.hls.trigger(Event.BUFFER_FLUSHING, { startOffset: fragInfo.start, endOffset: fragInfo.end, type: fragInfo.type });
					});
			//Mactrix additions end
					this.state = State.IDLE;
				}
				else {
			// current position is not buffered, but browser is still complaining about buffer full error
			// this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
			// in that case flush the whole buffer to recover
					logger.warn('buffer full error also desired time is not buffered, flush everything');
					this._fragCurrent = null;
			// flush everything
					this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
				}
			}
			if (this._bufferBeforeSeekingApplied === true) {
				this._bufferBeforeSeekingApplied = false;
				logger.log('Main: onBufferFull Rescheduling bufferBeforeSeeking');
			}

			break;
		default:
			break;
		}
	}

	_reduceMaxBufferLength(minLength) {
		let config = this.config;
		if (config.maxMaxBufferLength >= minLength) {
			// reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
			config.maxMaxBufferLength /= 2;
			logger.warn(`main:reduce max buffer length to ${config.maxMaxBufferLength}s`);
			// increase fragment load Index to avoid frag loop loading error after buffer flush
			this._fragLoadIdx += 2 * config.fragLoadingLoopThreshold;
		}
	}

	_checkBuffer() {
		let media = this.media;

		// if ready state different from HAVE_NOTHING (numeric value 0), we are allowed to seek
		if(media && media.readyState && !media.error
			&& (this.hls.bufferController.mediaSource.readyState === 'open' || this.hls.bufferController.mediaSource.readyState === 'ended')) {
			const hls = this.hls;

			let currentTime = media.currentTime;
			let mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media;
			let buffered = mediaBuffer.buffered;

			// adjust currentTime to start position on loaded metadata
			if(!this._loadedMetadata && buffered.length) {
				this._loadedMetadata = true;
		// only adjust currentTime if different from startPosition or if startPosition not buffered
		// at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
				let startPosition = media.seeking ? currentTime : this._startPosition;
				let startPositionBuffered = BufferHelper.isBuffered(mediaBuffer, startPosition);
		// if currentTime not matching with expected startPosition or startPosition not buffered
				if (currentTime !== startPosition || !startPositionBuffered) {
					logger.log(`target start position:${startPosition}`);
					// if startPosition not buffered, let's seek to buffered.start(0)
					if(!startPositionBuffered || startPosition < buffered.start(0)) {
						startPosition = buffered.start(0);
						logger.warn(`target start position not buffered, seek to buffered.start(0) ${startPosition}`);
					}
					logger.log(`adjust currentTime from ${currentTime} to ${startPosition}`);
					if(!this.hls.browTizen3 || this._levels[this._level].videoCodec !== undefined) { //we only need to delay this seek on audio only
						media.currentTime = startPosition;
					}
				}
				hls.trigger(Event.START_POSITION_SET, { startPosition }); //Mactrix line added, fix race condition when determining start time
			}
			else if (this._immediateSwitch) {
				this.immediateLevelSwitchEnd();
			}
			else {
				let bufferInfo = BufferHelper.bufferInfo(media, currentTime, 0);
				let expectedPlaying = !(media.paused || // not playing when media is paused
					media.ended || // not playing when media is ended
					hls._inSlowDetach ||
					media.buffered.length === 0); // not playing if nothing buffered
				let jumpThreshold = 0.5; // tolerance needed as some browsers stalls playback before reaching buffered range end
				let playheadMoving = currentTime !== this._lastCurrentTime;
				const config = this.config;

				if (playheadMoving) {
					// played moving, but was previously stalled => now not stuck anymore
					if (this._stallReported) {
						logger.warn(`playback not stuck anymore @${currentTime}, after ${Math.round(performance.now() - this._stalled)}ms`);
						this._stallReported = false;
					}
					this._stalled = undefined;
					this._nudgeRetry = 0;
					this._streamTimeoutArmed = false; //Mactrix line added
					//this._playbackStarted = true;
				}
				else {
					// playhead not moving
		/*
			if(expectedPlaying) {
		*/
					if(expectedPlaying && config.nudgeOnStall) { //Mactrix line changed, add ability to turn off stall detection
			// playhead not moving BUT media expected to play
						const tnow = performance.now();
						if(!this._stalled) {
			// stall just detected, store current time
							this._stalled = tnow;
							this._stallReported = false;
						}
						else {
			// playback already stalled, check stalling duration
			// if stalling for more than a given threshold, let's try to recover
							const stalledDuration = tnow - this._stalled;
							const bufferLen = bufferInfo.len;
							let nudgeRetry = this._nudgeRetry || 0;
			// have we reached stall deadline ?
							if (bufferLen <= jumpThreshold && stalledDuration > config.lowBufferWatchdogPeriod * 1000) {
				// report stalled error once
								if (!this._stallReported) {
									this._stallReported = true;
									logger.warn(`playback stalling in low buffer @${currentTime}`);
									hls.trigger(Event.ERROR, {
										type: ErrorTypes.MEDIA_ERROR,
										details: ErrorDetails.BUFFER_STALLED_ERROR,
										fatal: false,
										buffer : bufferLen,
									});
								}
				// if buffer len is below threshold, try to jump to start of next buffer range if close
				// no buffer available @ currentTime, check if next buffer is close (within a config.maxSeekHole second range)
								let nextBufferStart = bufferInfo.nextStart;
								let delta = nextBufferStart - currentTime;

								if(nextBufferStart &&
									(delta < config.maxSeekHole) &&
									(delta > 0)
								) {
									this._nudgeRetry = ++nudgeRetry;
									const nudgeOffset = nudgeRetry * config.nudgeOffset;
				// next buffer is close ! adjust currentTime to nextBufferStart
				// this will ensure effective video decoding
									logger.log(`adjust currentTime from ${media.currentTime} to next buffered @ ${nextBufferStart} + nudge ${nudgeOffset}`);
									media.currentTime = nextBufferStart + nudgeOffset;
				// reset stalled so to rearm watchdog timer
									this._stalled = undefined;
									hls.trigger(Event.ERROR, {
										type: ErrorTypes.MEDIA_ERROR,
										details: ErrorDetails.BUFFER_SEEK_OVER_HOLE,
										fatal: false,
										hole : nextBufferStart + nudgeOffset - currentTime,
									});
								}
							}
							else if (bufferLen > jumpThreshold && stalledDuration > config.highBufferWatchdogPeriod * 1000) {
				// report stalled error once
								if (!this._stallReported) {
									this._stallReported = true;
									logger.warn(`playback stalling in high buffer @${currentTime}`);
									hls.trigger(Event.ERROR, {
										type: ErrorTypes.MEDIA_ERROR,
										details: ErrorDetails.BUFFER_STALLED_ERROR,
										fatal: false,
										buffer : bufferLen,
									});
								}
				// reset stalled so to rearm watchdog timer
								this._stalled = undefined;
								this._nudgeRetry = ++nudgeRetry;
								if (nudgeRetry < config.nudgeMaxRetry) {
									let oldCurrentTime = media.currentTime;
									const targetTime = currentTime + nudgeRetry * config.nudgeOffset;
									logger.log(`adjust currentTime from ${oldCurrentTime} to ${targetTime}`);
				// playback stalled in buffered area ... let's nudge currentTime to try to overcome this
									media.currentTime = targetTime;
									hls.trigger(Event.ERROR, {
										type: ErrorTypes.MEDIA_ERROR,
										details: ErrorDetails.BUFFER_NUDGE_ON_STALL,
										fatal: false,
									});
								}
								else {
									logger.error(`still stuck in high buffer @${currentTime} after ${config.nudgeMaxRetry}, raise fatal error`);
									hls.trigger(Event.ERROR, { type: ErrorTypes.MEDIA_ERROR, details: ErrorDetails.BUFFER_STALLED_ERROR, fatal: true });
								}
							}
						}
					}
		//Mactrix additions start
		//we still want to receive the buffer stall error if the nudge functionality is disabled, as we use it to tell when we enter the buffered state
					else if(expectedPlaying && !this.hls.config.nudgeOnStall) {
						const tnow = performance.now();
						if(!this._stalled) {
							this._stalled = tnow;
							this._stallReported = false;
						}
						else {
							const stalledDuration = tnow - this._stalled;
							const bufferLen = bufferInfo.len;
							if (stalledDuration > config.lowBufferWatchdogPeriod * 1000) {
								//THIS IS A WORKAROUND, REMOVE ONCE AUDIO GAP SUPPORT IS FULLY IMPLEMENTED
								//if latebound audio is known to have gaps, jump over buffer holes
								if(this._altAudio) {
									this.seekOverNearbyAudioGap(true);
								}

								if (!this._stallReported && !this._audioGapSeeking) {
									this._stallReported = true;
									logger.warn(`playback stalling @${currentTime}`);

									if(bufferLen <= jumpThreshold) {
										hls.trigger(Event.ERROR, {
											type: ErrorTypes.MEDIA_ERROR,
											details: ErrorDetails.BUFFER_STALLED_ERROR,
											fatal: false,
											buffer : bufferLen,
										});
									}

									this._streamTimeoutArmed = true;
								}
							}
						}
					}
			//Mactrix additions end
				}
			}

			this._lastCurrentTime = currentTime;
		}
	}

	onFragLoadEmergencyAborted() {
		this.state = State.IDLE;
	// if loadedmetadata is not set, it means that we are emergency switch down on first frag
	// in that case, reset startFragRequested flag
		if(!this._loadedMetadata) {
			this._startFragRequested = false;
			this._nextLoadPosition = this._startPosition;
		}
		this.tick();
	}

	onBufferFlushed() {
	/* after successful buffer flushing, filter flushed fragments from bufferedFrags
	  use mediaBuffered instead of media (so that we will check against video.buffered ranges in case of alt audio track)
	*/
		const media = this.mediaBuffer ? this.mediaBuffer : this.media;
		this._bufferedFrags = this._bufferedFrags.filter(frag => {
			return BufferHelper.isBuffered(media, (frag.startPTS + frag.endPTS) / 2);
		});

		// reset reference to frag
		this._fragPrevious = null;

	// increase fragment load Index to avoid frag loop loading error after buffer flush
		this._fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
	// move to IDLE once flush complete. this should trigger new fragment loading
		if(this.state === State.BUFFER_FLUSHING && this.hls.bufferController.readyForData === true) {
			this.endBufferWait();
			this.state = State.IDLE;
		}
		else if(this.state === State.PARSED) {
			this.state = State.BUFFER_FLUSHING;
			/*this._bufferNextDuplicate = true;*/
			this._flushOnStoppedBuffering.forEach((fragInfo) => {
				this.hls.trigger(Event.BUFFER_FLUSHING, { startOffset: fragInfo.start, endOffset: fragInfo.end, type: fragInfo.type });
			});
		}
		else {
			// move to IDLE once flush complete. this should trigger new fragment loading
			this.state = State.IDLE;
			this.tick();
		}
	}

	onBufferWait() {
		var frag = this._fragCurrent;

		logger.log('Main: BufferWait');

		if (frag) {
			if (frag.loader) {
				frag.loader.abort();
			}
			this._fragCurrent = null;

			if (this._bufferBeforeSeekingApplied === true) {
				this._bufferBeforeSeekingApplied = false;
				logger.log('Main: Rescheduling bufferBeforeSeeking');
			}
		}

		//All other cases should switch to FLUSHING
		if (this.state === State.FRAG_LOADING || this.state === State.KEY_LOADING || this.state === State.FRAG_LOADING_WAITING_RETRY) {
			this.state = State.BUFFER_FLUSHING;
		}

		if (this._waitForFlush) {
			logger.warn('Main: onBufferWait Already waiting');
		}
		this._waitForFlush = true; //Should only set it to true here
	}

	endBufferWait() {
		if (this._waitForFlush) {
			logger.log('Main: end BufferWait No longer waiting');
		}
		this._waitForFlush = false; //Should only set it to false here
	}

	_checkIfBufferReady() {
		if (this.hls.bufferController.readyForData === true) {
			this.endBufferWait();
			this.state = State.IDLE;
		}
		else {
			this.state = State.BUFFER_FLUSHING;
		}
	}

	swapAudioCodec() {
		this._audioCodecSwap = !this._audioCodecSwap;
	}

	computeLivePosition(sliding, levelDetails) {
		let targetLatency = this.config.liveSyncDuration !== undefined ?
			this.config.liveSyncDuration :
			this.config.liveSyncDurationCount * levelDetails.targetduration;

		return sliding + Math.max(0, levelDetails.totalduration - targetLatency);
	}

	set bufferBeforeSeeking(time) {
		logger.log(`main bufferBeforeSeeking set to ${time}`);
		this._bufferBeforeSeekingTime = time;
		this._bufferBeforeSeekingApplied = false;

		if (this._fragCurrent && this._fragCurrent.loader) {
			this._fragCurrent.loader.abort();
		}
		this._fragCurrent = null;
		this._fragPrevious = null;
		this.state = State.IDLE;
	}

	get bufferBeforeSeeking() {
		return this._bufferBeforeSeekingTime;
	}

	get liveSyncPosition() {
		return this._liveSyncPosition;
	}

	set liveSyncPosition(value) {
		this._liveSyncPosition = value;
	}

	addToDeadFragList(deadSn) {
		if(this._levels[this._level]) {
			this._levels[this._level].deadFragList.push(deadSn);
		}

		//we mark the dead frag before we set the delay for next frag load, so when marking a dead frag, tell controller to set delay to 0
		this._skipReloadDelay = true;
	}

	removeDeadFrag(index, fragList) {
		if(fragList[index + 1]) {
			//adjust the gap of the next frag
			if(fragList[index].gap === undefined) {
				fragList[index].gap = 0;
			}
			if(fragList[index + 1].gap === undefined) {
				fragList[index + 1].gap = 0;
			}
			fragList[index + 1].gap += (fragList[index].gap + (fragList[index + 1].pdt - fragList[index].pdt));
			fragList.splice(index, 1);

			//alter fragList.index values so that frag selector won't enter an infinite loop
			for(let i = index; i < fragList.length; i++) {
				fragList[i].index--;
			}
		}
		else if(fragList[index]) {
			//no next frag, just truncate. endSN will be fixed in onLevelLoaded
			fragList.splice(index, 1);
		}
	}
}
export default StreamController;



// WEBPACK FOOTER //
// ./src/hlsjs/controller/stream-controller.js